import { FileOutlined, InfoCircleFilled, RollbackOutlined } from "@ant-design/icons"
import {
  collection,
  doc,
  addDoc,
  getDocs,
  getDoc,
  query,
  orderBy,
  serverTimestamp,
  where,
  updateDoc,
} from "firebase/firestore"

// import AntDesign
import {
  Col,
  Divider,
  Row,
  Select,
  Space,
  Tooltip,
  InputNumber,
  Typography,
  Progress,
  Button,
  Switch,
  Tabs,
  Skeleton,
  Input,
  Slider,
  Popconfirm,
  Spin,
} from "antd"

//import icons from antd
import {
  CheckCircleFilled,
  ClearOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons"

import { useEffect, useState } from "react"

import { useLocation, useNavigate } from "react-router-dom"
import { useAuthContext } from "../../../hooks/useAuthContext"
import { db } from "../../../firebase/config"
import CalculationsPopup from "../../../components/Manager/Calculations/CalculationsPopup"
import { Notification } from "../../../components/Notification"
import "../../css/AdminCalculations.css"
import axiosInstance from "../../../axios/axiosConfig"

const { Option } = Select
const { Text, Title, Link } = Typography
const { TextArea } = Input

export default function AdminCalculations() {
  // global loading
  const [globalLoading, setGlobalLoading] = useState(true)

  //user from auth context
  const { user } = useAuthContext()

  // get user specific updates for a price
  // such as extra percent for a user
  const [userExtraPercent, setUserExtraPercent] = useState(0)

  // gets the data from the link
  const location = useLocation()

  //whole state
  const totalState = location.state

  // location state
  let dataFromState

  if (location.state && location.state.changedByDesigner) {
    dataFromState = location.state.selectedProduct
  } else {
    dataFromState = location.state
  }

  //navigation
  const navigate = useNavigate()

  //disables update price button until calculate has been pressed
  //admin update Price Button disable
  const [updatePriceButton, setUpdatePriceButton] = useState(true)

  //Machines
  const [machines, setMachines] = useState(null)
  const [selectedMachine, setSelectedMachine] = useState(null)
  const [machineSpeed, setMachineSpeed] = useState(0)
  const [machineAlsm, setMachineAlsm] = useState(0)
  const [machineElectricity, setMachineElectricity] = useState(0)
  const [machineWorker, setMachineWork] = useState(0)
  const [machineAmortization, setMachineAmortization] = useState(0)

  //Clients
  const [clients, setClients] = useState([])
  const [selectedClient, setSelectedClient] = useState(null)
  const [clientsProfit, setClientsProfit] = useState(0)
  const [loadingClients, setLoadingClients] = useState(true)
  const [selectedClientId, setSelectedClientId] = useState(0)
  const [selectedClientName, setSelectedClientName] = useState("none")
  const [extraProfitSlider, setExtraProfitSlider] = useState(0)

  //formatter for extra profit slider
  const formatter = (value) => `${value}%`

  // //Products
  const [productName, setProductName] = useState(null)

  //Knives
  //init button text for selecting knives
  const initalKniveButtonText = "Select"
  // const [knives, setKnives] = useState([]);
  const [kniveSpaceBetweenRows, setKniveSpaceBetweenRows] = useState(3)
  // const [kniveGapRaport, setKniveGapRaport] = useState(0);
  const [selectedKnifeCode, setSelectedKnifeCode] = useState("none")
  const [selectedKnifeId, setSelectedKnifeId] = useState("none")
  const [kniveButtonText, setKniveButtonText] = useState(initalKniveButtonText)

  //Label Settings
  const [labelCount, setLabelCount] = useState(0)
  const [labelHeight, setLabelHeight] = useState(0)
  const [labelWidth, setLabelWidth] = useState(0)
  const [rowBalance, setRowBalance] = useState(0)

  //Material
  const [material, setMaterial] = useState(0)
  const [materialEurM2, setMaterialEurM2] = useState(0)
  const [materialGM2, setMaterialGM2] = useState(0)
  const [selectedMaterial, setSelectedMaterial] = useState("none")
  const [materialLoading, setMaterialLoading] = useState(false)
  const [selectedMaterialId, setSelectedMaterialId] = useState(null)

  //Format width
  const [formatWidth, setFormatWidth] = useState(0)
  const [formatWidthList, setFormatWidthList] = useState([])

  //Number of columns
  const [numberOfColumns, setNumberOfColumns] = useState(0)

  //CMYK
  const [cmykColors, setCmykColors] = useState(0)
  const [cmykPercent, setCmykPercent] = useState(1)

  //Pantone
  const [pantoneColors, setPantoneColors] = useState(0)
  const [pantonePercent, setPantonePercent] = useState(0)

  //Covering W
  const [coveringWCount, setCoveringWCount] = useState(0)
  const [coveringWPercent, setCoveringWPercent] = useState(0)

  //Varnish
  const [varnish, setVarnish] = useState(0)
  const [varnishType, setVarnishType] = useState("none")
  const [varnishXpretp, setVarnishXpretp] = useState(0)
  // const [varnishCost, setVarnishCost] = useState(0);
  const [varnishUse, setVarnishUse] = useState(0)
  const [varnishPercent, setVarnishPercent] = useState(1)
  const [selectedVarnish, setSelectedVarnish] = useState("none")
  const [selectedVarnishId, setSelectedVarnishId] = useState(null)

  //Gold or Silver
  const [goldOrSilver, setGoldOrSilver] = useState(0)
  const [goldOrSilverPercent, setGoldOrSilverPercent] = useState(0)

  //Relief
  const [relief, setRelief] = useState(null)
  const [reliefMeters, setReliefMeters] = useState(0)
  const [reliefRunningMeters, setReliefRunningMeters] = useState(0)
  const [reliefTimePerMin, setReliefTimePerMin] = useState(0)
  const [selectedReliefValue, setSelectedReliefValue] = useState(0)
  const [selectedReliefUse, setSelectedReliefUse] = useState(0)
  const [selectedRelief, setSelectedRelief] = useState("No")
  const [selectedReliefId, setSelectedReliefId] = useState(null)

  //Foil
  const [foil, setFoil] = useState(null)
  const [foilCount, setFoilCount] = useState(0)
  const [foilCosts, setFoilCosts] = useState(0)
  const [foilColor, setFoilColor] = useState("none")
  const [foilPercent, setFoilPercent] = useState(0)
  const [selectedFoilColor, setSelectedFoilColor] = useState("none")
  const [selectedFoilId, setSelectedFoilId] = useState(null)

  //Production1
  const [productionCosts, setProductionCosts] = useState(0)
  // const [productionAdjustRunningMeters, setProductionAdjustRunningMeters] = useState(0);
  const [productionRunningMetersMin, setProductionRunningMetersMin] = useState(0)
  const [productionTimePerMinute, setProductionTimePerMinute] = useState(0)
  const [selectedProductionMachine, setSelectedProductionMachine] = useState("")
  const [selectedProductionMachineId, setSelectedProductionMachineId] = useState(0)

  //Production2
  const [productionCosts2, setProductionCosts2] = useState(0)
  // const [productionAdjustRunningMeters2, setProductionAdjustRunningMeters2] = useState(0);
  const [productionRunningMetersMin2, setProductionRunningMetersMin2] = useState(0)
  const [productionTimePerMinute2, setProductionTimePerMinute2] = useState(0)
  const [selectedProductionMachine2, setSelectedProductionMachine2] = useState("")
  const [selectedProductionMachine2Id, setSelectedProductionMachine2Id] = useState(0)

  //Rastra
  const [rastra, setRastra] = useState(0)

  //Total Price
  const [totalPrice, setTotalPrice] = useState(0)
  const [fixedPrice, setFixedPrice] = useState(false)
  const [totalFixedPrice, setTotalFixedPrice] = useState(0)
  const [disableFixedPriceButton, setDisableFixedPriceButton] = useState(true)

  //hide or show dynamic price
  const [dynamicPriceHidden, setDynamicPriceHidden] = useState(true)

  //function for handling fixed price
  const handleFixedPrice = () => {
    setFixedPrice((prev) => !prev)
    setDisableFixedPriceButton((prev) => !prev)
  }

  //Total Weight
  const [labelWeight, setTotalLabeWeight] = useState(0)

  //visibility for advanced panel
  const [visible, setVisible] = useState(false)

  //sets the active key from machine select to tabs
  const [activeKey, setActiveKey] = useState("1")

  //sets the visibility of the tooltip for RowBalance
  const [tooltipRowBalance, setTooltipRowBalance] = useState(false)

  //sets save buttons state
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(true)

  //How many times will machine go trought
  const [howManyTimes, setHowManyTimes] = useState(1)

  const [totalPointsRemaining, setTotalPointsRemaining] = useState(0)
  const [pointsRemaining, setPointsRemaining] = useState(0)

  // Krasu paterins (Color spent)
  const [krasuPaterinsCMYK, setKrasuPaterinsCMYK] = useState()
  const [krasuPaterinsPantone, setKrasuPaterinsPantone] = useState()
  const [krasuPaterinsLaka, setKrasuPaterinsLaka] = useState()
  const [krasuPaterinsZeltaKrasa, setKrasuPaterinsZeltaKrasa] = useState()

  //krasu cenas eur kg (color prices eur/kg)
  const [krasuCenaEurKgLaka, setKrasuCenaEurKgLaka] = useState()
  const [krasuCenaEurKgCMYK, setKrasuCenaEurKgCMYK] = useState()
  const [krasuCenaEurKgPantone, setKrasuCenaEurKgPantone] = useState()
  const [krasuCenaEurKgZeltsUnSudrabs, setKrasuCenaEurKgZeltsUnSudrabs] = useState()
  const [krasuCenaEurKgSedzosaKrasaW, setKrasuCenaEurKgSedzosaKrasaW] = useState()

  //pieregulesana t.m.
  const [pieregulesanaPiekartosana, setPieregulesanaPiekartosana] = useState()
  const [pieregulesanaCmykGatavieToni, setPieregulesanaCmykGatavieToni] = useState()
  const [pieregulesanaPantone, setPieregulesanaPantone] = useState()

  //sets the state for price loading
  const [totalLoading, setTotalLoading] = useState(false)

  // sets dynamic prices
  const [dynamicPrice, setDynamicPrice] = useState([])

  // sets dynamic fixed prices
  const [dynamicFixedPrice, setDynamicFixedPrice] = useState([])

  //product file link
  const [adminProductFileLink, setAdminProductFileLink] = useState(null)

  //sequential production
  const [secigaRazosana, setSecigaRazosa] = useState(1)

  //user info
  const [priceUser, setPriceUser] = useState(null)
  const [priceUserEmail, setPriceUserEmail] = useState(null)

  //created time
  const [createdTime, setCreatedTime] = useState(null)

  //comment
  const [userComment, setUserComment] = useState("")

  //state for startup calculation
  const [knifePrice, setKnifePrice] = useState(0)
  const [newKnife, setNewKnife] = useState(false)
  const [knifeShape, setKnifeShape] = useState("none")
  const [newKnifeMessage, setNewKnifeMessage] = useState("")
  const [newKnifeRadiuss, setNewKnifeRadius] = useState(0)
  const [newKnifeFile, setNewKnifeFile] = useState("")

  //checks if its a new job
  const [newJob, setNewJob] = useState(false)
  const [totalPlateCost, setTotalPlateCost] = useState(0)
  const [plateObjects, setPlateObjects] = useState({})
  //checks if plate object is empty
  const plateObjectIsEmpty = Object.keys(plateObjects).length === 0

  //hotprint data
  const [hotprintMeterPerMin, setHotprintMeterPerMin] = useState(0)
  const [hotprintCostsPerH, setHotPrintCostsPerH] = useState(0)
  const [hotprintAdjustmentTimeMin, setHotprintAdjustmentTimeMin] = useState(0)
  const [hotprintAdjustmentRunningMeters, setHotprintAdjustmentRunningMeters] = useState(0)

  //changable space data
  const [changableSpace, setChangableSpace] = useState(false)

  //admin comment
  const [adminComment, setAdminComment] = useState(null)
  //designer comment
  const [designerComment, setDesignerComment] = useState(null)

  //checks if was sent from designer
  const [wasSentFromDesigner, setWasSentFromDesigner] = useState(false)

  //disables or enables approve button
  const [disabledApproveButton, setDisabledApproveButton] = useState(false)

  const changeDynamicPriceSwitch = (checked) => {
    setDynamicPriceHidden(!dynamicPriceHidden)
  }

  //updates row balance on every change
  useEffect(() => {
    let balance = 0
    if (selectedMaterial !== "none") {
      balance =
        Number(formatWidth) -
        (Number(numberOfColumns) * Number(labelWidth) +
          (Number(numberOfColumns) - 1) * Number(kniveSpaceBetweenRows) +
          2 * Number(machineAlsm))
    }
    setRowBalance(balance)
  }, [
    formatWidth,
    numberOfColumns,
    labelWidth,
    kniveSpaceBetweenRows,
    machineAlsm,
    selectedMaterial,
  ])

  //ADMIN DATA FETCH
  //updates data from location and puts everything where it belongs
  useEffect(() => {
    //set price user user
    setPriceUserEmail(dataFromState.userEmail)
    setPriceUser(dataFromState.user)

    //created time
    setCreatedTime(dataFromState.date.created)

    //sets machine
    if (machines) {
      const adminMachine = machines.find((data) => data.machine === dataFromState.machine)
      setSelectedMachine(adminMachine.machine)
      setMachineSpeed(adminMachine.speed)
      setMachineAlsm(adminMachine.alsm)
      setMachineElectricity(adminMachine.costs.electricity)
      setMachineWork(adminMachine.costs.worker)
      setMachineAmortization(adminMachine.costs.amortization)
      setTotalPointsRemaining(adminMachine.stations)
      console.log(adminMachine)

      //total points remaining
      let reliefUse = 0
      if (dataFromState.print.reliefId !== null) {
        reliefUse = 1
      }
      let result =
        dataFromState.print.cmykColors +
        dataFromState.print.pantoneColors +
        dataFromState.print.coveringWCount +
        dataFromState.print.varnishUse +
        dataFromState.print.goldOrSilver +
        reliefUse +
        dataFromState.print.foilCount
      setPointsRemaining(adminMachine.stations * dataFromState.advanced.howManyTimes - result)

      if (adminMachine.machine === "Arsoma") {
        setActiveKey(`2`)
      } else if (adminMachine.machine === "Viva") {
        setActiveKey(`1`)
      } else if (adminMachine.machine === "Cutter") {
        setActiveKey(`0`)
      }
    }

    //sets client
    setSelectedClient(dataFromState.client)
    setClientsProfit(dataFromState.clientsProfit)
    setSelectedClientId(dataFromState.clientId)
    setSelectedClientName(dataFromState.client)

    //sets product
    setProductName(dataFromState.product.productName)

    //label count
    setLabelCount(dataFromState.labelCount)

    //handle knife
    if (dataFromState.knifeCode) {
      if (dataFromState.knifeCode !== "New Knife") {
        const searchByCode = async (code) => {
          try {
            const response = await axiosInstance.get(
              `/api/searchByCode?code=${encodeURIComponent(code)}`
            )
            const knifeData = response.data
            if (knifeData) {
              setKniveButtonText(knifeData.code)
              setKniveSpaceBetweenRows(knifeData.spaceBetweenRows)
              setLabelWidth(knifeData.width)
              setLabelHeight(knifeData.height)
              setSelectedKnifeCode(knifeData.code)
              setSelectedKnifeId(dataFromState.id)
              setNumberOfColumns(knifeData.rowss)
              console.log(knifeData)
            }
          } catch (error) {
            console.error("Failed to fetch data:", error)
          }
        }

        searchByCode(dataFromState.knifeCode)
      } else {
        setKniveButtonText("New Knife")
        setKniveSpaceBetweenRows(3)
        setLabelWidth(dataFromState.labelWidth)
        setLabelHeight(dataFromState.labelHeight)
        setSelectedKnifeCode("New Knife")
        setSelectedKnifeId("New Knife")
        setNumberOfColumns(dataFromState.numberOfColumns)
      }
    }

    //handle material
    if (dataFromState.material) {
      const materialRef = doc(db, "materials", dataFromState.materialId)
      getDoc(materialRef).then((docSnap) => {
        if (docSnap.exists()) {
          let materialData = docSnap.data()
          setMaterialEurM2(materialData.eurM2)
          setMaterialGM2(materialData.gM2)
          setSelectedMaterial(materialData.material)
          setSelectedMaterialId(dataFromState.materialId)
          setFormatWidthList(materialData.widths)
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!")
        }
      })
    }

    //handle format
    setFormatWidth(dataFromState.formatWidth)

    //handle row balance
    setRowBalance(dataFromState.advanced.rowBalance)

    //handle sequential production
    setSecigaRazosa(dataFromState.advanced.sequentialProduction)

    //handle advanced
    if (dataFromState.advanced.extraProfit !== 0 || dataFromState.advanced.fixedPrice === true) {
      setVisible(true)

      //checks fixed price
      if (dataFromState.advanced.fixedPrice === true) {
        setFixedPrice(true)
        setDisableFixedPriceButton(false)
        setTotalFixedPrice(dataFromState.totalFixedPrice)
      }

      //checks extra profit
      if (dataFromState.advanced.extraProfit !== 0) {
        setExtraProfitSlider(dataFromState.advanced.extraProfit)
      }
    }

    //handles print settings
    //cmyk
    setCmykColors(dataFromState.print.cmykColors)

    //pantone
    setPantoneColors(dataFromState.print.pantoneColors)
    setPantonePercent(dataFromState.print.pantonePercent)

    //white
    setCoveringWCount(dataFromState.print.coveringWCount)
    setCoveringWPercent(dataFromState.print.coveringWPercent)
    setCmykPercent(1)

    //varnish
    if (varnish && dataFromState.print.varnishId !== null) {
      const adminVarnish = varnish.find((data) => data.id === dataFromState.print.varnishId)
      setVarnishType(adminVarnish.type)
      setVarnishXpretp(adminVarnish.xpretp)
      setVarnishUse(adminVarnish.used)
      setSelectedVarnish(adminVarnish.type)
      setSelectedVarnishId(adminVarnish.id)
      setVarnishPercent(1)
    }

    //silver or gold
    setGoldOrSilver(dataFromState.print.goldOrSilver)
    setGoldOrSilverPercent(dataFromState.print.goldOrSilverPercent)

    //relief
    if (relief && dataFromState.print.reliefId !== null) {
      const adminRelief = relief.find((data) => data.id === dataFromState.print.reliefId)
      setReliefMeters(adminRelief.meters)
      setReliefRunningMeters(adminRelief.runningMeters)
      setReliefTimePerMin(adminRelief.timePerMin)
      setSelectedReliefValue(adminRelief)
      setSelectedReliefUse(adminRelief.value)
      setSelectedRelief(adminRelief.tag)
      setSelectedReliefId(adminRelief.id)
    }

    //foil
    if (foil && dataFromState.print.foilId !== null) {
      const adminFoil = foil.find((data) => data.id === dataFromState.print.foilId)
      setFoilCosts(adminFoil.costs)
      setFoilColor(adminFoil.color)
      setSelectedFoilColor(adminFoil.color)
      setSelectedFoilId(adminFoil.id)
      setFoilPercent(dataFromState.print.foilPercent)
      setFoilCount(dataFromState.print.foilCount)
    }

    //user comments
    if (dataFromState.userComment != null) {
      setUserComment(dataFromState.userComment)
    }

    //set price
    setTotalPrice(dataFromState.price)

    //set dynamic price
    setDynamicPrice(dataFromState.dynamicPrice)

    //sets fixed dynamic price
    if (dataFromState.advanced.fixedPrice) {
      setDynamicFixedPrice(dataFromState.dynamicFixedPrice)
    }

    console.log(dataFromState)

    //sets sequenciol production
    setSecigaRazosa(dataFromState.advanced.sequentialProduction)

    //set product file link
    setAdminProductFileLink(dataFromState.product.productFileUrl)

    //sets data for a new knife
    if (dataFromState.startup && dataFromState.startup.newKnife) {
      setNewKnife(dataFromState.startup.newKnife)
      setKnifePrice(dataFromState.startup.knifePrice)
      setKniveButtonText("New Knife...")
      setKniveSpaceBetweenRows(3)
      setLabelWidth(dataFromState.labelWidth)
      setLabelHeight(dataFromState.labelHeight)
      setSelectedKnifeCode("New Knife")
      setSelectedKnifeId("New Knife")
      setNumberOfColumns(dataFromState.numberOfColumns)
      setKnifeShape(dataFromState.startup.knifeShape)
    }

    if (dataFromState.startup) {
      if (dataFromState.startup.newKnife) {
        setNewKnifeMessage(dataFromState.startup.newKnifeObject.message)
        setNewKnifeFile(dataFromState.startup.newKnifeObject.fileLink)
        setNewKnifeRadius(dataFromState.startup.newKnifeObject.radius)
      }
    }

    //sets data for new job
    if (dataFromState.startup && dataFromState.startup.newJob) {
      setNewJob(dataFromState.startup.newJob)
      setTotalPlateCost(dataFromState.startup.newJob)
      setPlateObjects(dataFromState.startup.plateObjects)
    }

    //sets changable space
    if (dataFromState.advanced.changableSpace && dataFromState.advanced.changableSpace) {
      setChangableSpace(dataFromState.advanced.changableSpace)
      setVisible(true)
    }

    //sets admin comment
    if (totalState.changedByDesigner && totalState.changedByDesigner === true) {
      setWasSentFromDesigner(totalState.changedByDesigner)
      setDesignerComment(totalState.designerComment)
    }

    setTimeout(() => {
      setGlobalLoading(false)
    }, 1500)
  }, [dataFromState, machines, varnish, relief, foil, totalState])

  //handles updating the state
  const handleAmountChange = (index, event) => {
    const values = [...dynamicPrice]
    values[index][event.target.name] = Number(event.target.value)
    setDynamicPrice(values)
    console.log(index)
  }

  //handles adding amount
  const handleAddAmount = () => {
    setDynamicPrice([...dynamicPrice, { quantity: 0, price: 0, labelWeight: 0, m2: 0 }])
  }

  //handles removing amount
  const removeAmountFields = (index) => {
    const values = [...dynamicPrice]
    values.splice(index, 1)
    setDynamicPrice(values)
  }

  //updates all the dynamically created prices with HandleCalculate
  const updateDynamicPrices = (param) => {
    const newPrice = param.map((element) => {
      let result = handleCalculate(element.quantity)
      return {
        ...element,
        price: Number(result.cenaPar1000uzlimemEur),
        labelWeight: Number(result.tiraisSvarsKg),
        m2: Number(result.papiraPaterins),
      }
    })
    setDynamicPrice(newPrice)
  }

  //use Effect for calculating the machine points
  useEffect(() => {
    let result =
      cmykColors +
      pantoneColors +
      coveringWCount +
      varnishUse +
      goldOrSilver +
      selectedReliefUse +
      foilCount
    setPointsRemaining(totalPointsRemaining * howManyTimes - result)
  }, [
    cmykColors,
    pantoneColors,
    coveringWCount,
    varnishUse,
    goldOrSilver,
    selectedReliefUse,
    foilCount,
    howManyTimes,
    totalPointsRemaining,
  ])

  const style = {
    background: "white",
    borderRadius: "3px",
  }

  //##### FIXED DYNAMIC PRICE #####
  //handles updating the state for dynamic fixed price
  const handleAmountChangeFixed = (index, event) => {
    const values = [...dynamicFixedPrice]
    values[index][event.target.name] = Number(event.target.value)
    setDynamicFixedPrice(values)
  }

  //handles adding amount
  const handleAddAmountFixed = () => {
    setDynamicFixedPrice([...dynamicFixedPrice, { quantity: 0, price: 0, labelWeight: 0, m2: 0 }])
  }

  //handles removing amount dynamic fixed price
  const removeAmountFieldsFixed = (index) => {
    const values = [...dynamicFixedPrice]
    values.splice(index, 1)
    setDynamicFixedPrice(values)
  }

  //updates all the dynamically fixed created prices with HandleCalculate
  const updateDynamicPricesFixed = (param) => {
    const newPrice = param.map((element) => {
      let result = handleCalculate(element.quantity)
      return {
        ...element,
        labelWeight: Number(result.tiraisSvarsKg),
        m2: Number(result.papiraPaterins),
      }
    })
    setDynamicFixedPrice(newPrice)
  }

  useEffect(() => {
    //FETCHING MACHINES
    const machinesRef = collection(db, "machines")
    getDocs(machinesRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setMachines(results)
    })
    //FETCHING CLIENTS
    const clientsRef = collection(db, "clients")
    const clientsQ = query(clientsRef, where("user", "==", priceUser))
    getDocs(clientsQ).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      const filtered = results.filter((res) => res.approved === true)
      setClients(filtered)
      setLoadingClients(false)
    })

    //FETCHING MATERIAL
    const materialRef = collection(db, "materials")
    const materialQuery = query(materialRef, where("stock", "==", true))
    setMaterialLoading(true)
    getDocs(materialQuery).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setMaterial(results)
      setMaterialLoading(false)
    })

    //FETCHING VARNISH
    const varnishRef = collection(db, "varnish")
    const varnishQuery = query(varnishRef, orderBy("costs", "asc"))
    getDocs(varnishQuery).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setVarnish(results)
    })
    //FETCHING RELIEF
    const reliefRef = collection(db, "relief")
    const reliefQuery = query(reliefRef, orderBy("value", "asc"))
    getDocs(reliefQuery).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setRelief(results)
    })
    //FETCHING FOIL
    const foilRef = collection(db, "foil")
    getDocs(foilRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setFoil(results)
    })

    //FETCHING HOTPRINT
    const hotprintRef = doc(db, "hotprint", "GDmYoXX9pwy61D8N1zDl")
    getDoc(hotprintRef).then((snapshot) => {
      const hotprintData = snapshot.data()
      console.log(hotprintData.adjustmentTime)
      setHotprintMeterPerMin(hotprintData.meterPerMinute)
      setHotPrintCostsPerH(hotprintData.printCostsPerHour)
      setHotprintAdjustmentTimeMin(hotprintData.adjustmentTime)
      setHotprintAdjustmentRunningMeters(hotprintData.adjustmentRunningMeters)
    })

    //FETCHING PRODUCTION DEFAULTS
    const porductDefaultRef2 = doc(db, "productionCosts", "GalDdGckTxeJHAEoD4nA")
    getDoc(porductDefaultRef2).then((doc) => {
      let result = doc.data()
      setSelectedProductionMachine2Id(doc.id)
      setProductionCosts2(result.costs)
      // setProductionAdjustRunningMeters2(result.adjustRunningMeters);
      setProductionRunningMetersMin2(result.runningMetersMin)
      setProductionTimePerMinute2(result.timeperminute)
      setSelectedProductionMachine2(result.machine)
    })
    const porductDefaultRef = doc(db, "productionCosts", "ygJHdF8Z6y3uR5H567BY")
    getDoc(porductDefaultRef).then((doc) => {
      let result = doc.data()
      setSelectedProductionMachineId(doc.id)
      setProductionCosts(result.costs)
      // setProductionAdjustRunningMeters(result.adjustRunningMeters);
      setProductionRunningMetersMin(result.runningMetersMin)
      setProductionTimePerMinute(result.timeperminute)
      setSelectedProductionMachine(result.machine)
    })

    //FETCHING RASTRA
    const rastraRef = collection(db, "rastra")
    getDocs(rastraRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      setRastra(results[0].grams)
    })
    //FETCHING KRASUPATERINS
    const colorRef = collection(db, "krasuPaterins")
    getDocs(colorRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      const cmykResult = results.find((item) => item.type === "CMYK")
      setKrasuPaterinsCMYK(Number(cmykResult.consumption))
      const pantoneResult = results.find((item) => item.type === "Pantone")
      setKrasuPaterinsPantone(Number(pantoneResult.consumption))
      const varnishResult = results.find((item) => item.type === "Varnish")
      setKrasuPaterinsLaka(Number(varnishResult.consumption))
      const goldResult = results.find((item) => item.type === "Gold")
      setKrasuPaterinsZeltaKrasa(Number(goldResult.consumption))
    })
    //FETCHING KRASU CENA
    const colorPriceRef = collection(db, "colorPrices")
    getDocs(colorPriceRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      const varnishPriceResult = results.find((item) => item.type === "Varnish")
      setKrasuCenaEurKgLaka(Number(varnishPriceResult.price))
      const cmykPriceResult = results.find((item) => item.type === "CMYK")
      setKrasuCenaEurKgCMYK(Number(cmykPriceResult.price))
      const pantonePriceResult = results.find((item) => item.type === "Pantone")
      setKrasuCenaEurKgPantone(Number(pantonePriceResult.price))
      const goldPriceResult = results.find((item) => item.type === "GoldAndSilver")
      setKrasuCenaEurKgZeltsUnSudrabs(Number(goldPriceResult.price))
      const coveringWPriceResult = results.find((item) => item.type === "CoverW")
      setKrasuCenaEurKgSedzosaKrasaW(Number(coveringWPriceResult.price))
    })
    //FETCHING ADJUSTMENT TM
    const adjustmentRef = collection(db, "adjustmentTM")
    getDocs(adjustmentRef).then((snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        results.push({ id: doc.id, ...doc.data() })
      })
      const adjustingCleanResults = results.find((item) => item.type === "Adjustment Cleanup")
      setPieregulesanaPiekartosana(Number(adjustingCleanResults.time))
      const adjustmentCMYK = results.find((item) => item.type === "Adjustment CMYK")
      setPieregulesanaCmykGatavieToni(Number(adjustmentCMYK.time))
      const adjustmentPantone = results.find((item) => item.type === "Adjustment Pantone")
      setPieregulesanaPantone(Number(adjustmentPantone.time))
    })

    //user Extra Percent
    //checks if Previous user doc exists
    //FETCHING USER DOCUMENT
    //ADDING EXTRA PERCENTAGE
    if (priceUser) {
      const userDocRef = doc(db, "users", priceUser)
      getDoc(userDocRef).then((docSnap) => {
        if (docSnap.exists()) {
          setUserExtraPercent(docSnap.data().extraPercentage)
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!")
        }
      })
    }
  }, [priceUser])

  const handleMachine = (value, option, key) => {
    setSelectedMachine(option.value)
    setMachineSpeed(option.speed)
    setTotalPointsRemaining(option.stations)
    setPointsRemaining(option.stations)
    setMachineAlsm(option.alsm)
    setMachineElectricity(option.electricity)
    setMachineWork(option.worker)
    setMachineAmortization(option.amortization)
    setActiveKey(option.key)
    console.log(option.key)
  }

  const handleClient = (value, option) => {
    setSelectedClient(value)
    setClientsProfit(option.profit)
    setSelectedClientId(option.id)
    setSelectedClientName(option.value)
    console.log(option.id)
  }

  const clearKnives = () => {
    setKniveSpaceBetweenRows(3)
    setKniveButtonText(initalKniveButtonText)
    setLabelWidth(0)
    setLabelHeight(0)
    setSelectedKnifeCode("none")
    setSelectedKnifeId("none")
  }

  const handleMaterial = (value, option) => {
    setMaterialEurM2(option.eurM2)
    setMaterialGM2(option.gM2)
    setSelectedMaterial(option.value)
    setSelectedMaterialId(option.id)
    console.log(option)
    setFormatWidthList(option.widths)
    setFormatWidth(0)
  }

  const handleFormatWidth = (value, option) => {
    setFormatWidth(option.value)
  }

  const handleVarnish = (value, option) => {
    // setVarnishCost(option.costs);
    setVarnishType(value)
    setVarnishXpretp(option.xpretp)
    setVarnishUse(option.used)
    setSelectedVarnish(option.value)
    setSelectedVarnishId(option.id)
    console.log(option)
  }

  const handleRelief = (value, option) => {
    setReliefMeters(option.meters)
    setReliefRunningMeters(option.runningMeters)
    setReliefTimePerMin(option.timePerMin)
    setSelectedReliefValue(value)
    setSelectedReliefUse(option.value)
    setSelectedRelief(option.children)
    setSelectedReliefId(option.id)
    console.log(option)
  }

  const handleFoil = (value, option) => {
    setFoilCosts(option.costs)
    setFoilColor(value)
    setSelectedFoilColor(option.value)
    setSelectedFoilId(option.id)
    console.log(option)
  }

  //handles label Width & Knife width
  const handleLabelWidth = (value) => {
    setLabelWidth(value)
  }

  //handles label Height & Knife height
  const handleLabelHeight = (value) => {
    setLabelHeight(value)
  }

  const handleNumberOfColumns = (value) => {
    setNumberOfColumns(value)
  }

  //handles the totals calculation
  const handleTheTotalCalculate = (labels) => {
    var result = handleCalculate(labels)
    updateDynamicPrices(dynamicPrice)
    setTotalPrice(result.cenaPar1000uzlimemEur)
    setTotalLabeWeight(result.tiraisSvarsKg)
    updateDynamicPricesFixed(dynamicFixedPrice)
    setDisabledApproveButton(true)
  }

  //handles the state of a new job
  const handleNewJob = (value) => {
    setNewJob(value)
  }

  //checks for the machine and puts the right prices
  useEffect(() => {
    //checks if there is a new job
    if (newJob) {
      //prices for arsoma
      if (selectedMachine === "Arsoma") {
        let cmyk = cmykColors
        let pantone = pantoneColors
        let white = coveringWCount
        let varnish = selectedVarnish.includes("sector") ? 1 : 0
        let silverOrGold = goldOrSilver
        let relief = selectedReliefUse
        let total = cmyk + pantone + white + varnish + silverOrGold + relief
        let totalCost = total * 30
        setTotalPlateCost(totalCost)
        setPlateObjects({
          cmyk: cmykColors,
          pantone: pantoneColors,
          white: coveringWCount,
          varnish: selectedVarnish.includes("sector") ? 1 : 0,
          silverOrGold: goldOrSilver,
          relief: selectedReliefUse,
        })
      } else if (selectedMachine === "Viva") {
        let white = coveringWCount
        let varnish = selectedVarnish.includes("sector") ? 1 : 0
        let silverOrGold = goldOrSilver
        let total = white + varnish + silverOrGold
        let totalCostFlexo = total * 30
        let totalCostHotPrint = foilCount * 100
        let totalCostEmbossing = selectedReliefUse * 150
        let totalCost = totalCostFlexo + totalCostHotPrint + totalCostEmbossing
        setTotalPlateCost(totalCost)
        setPlateObjects({
          white: coveringWCount,
          varnish: selectedVarnish.includes("sector") ? 1 : 0,
          silverOrGold: goldOrSilver,
          relief: selectedReliefUse,
          foil: foilCount,
        })
      } else {
        setTotalPlateCost(0)
        setPlateObjects({})
      }
    }
  }, [
    newJob,
    cmykColors,
    selectedMachine,
    pantoneColors,
    foilCount,
    coveringWCount,
    selectedVarnish,
    goldOrSilver,
    selectedReliefUse,
  ])

  //returns knife price
  const knifeStartupPrice = () => {
    return (
      <>
        <Space>
          <Text>Knife price (eur) : </Text>
          <Text style={{ color: "#1677ff" }}>{knifePrice}</Text>
        </Space>
      </>
    )
  }

  //returns for Startup Costs
  const plateStartup = () => {
    return (
      <>
        <Space>
          <Text>Cost (eur)</Text>
          <Text style={{ color: "#1677ff" }}>{totalPlateCost}</Text>
        </Space>
        <ul>
          {plateObjectIsEmpty ? (
            <p>The object is empty.</p>
          ) : (
            Object.entries(plateObjects)
              .filter(([key, value]) => value > 0)
              .map(([key, value]) => (
                <li key={key}>
                  {key} count: {value}
                </li>
              ))
          )}
        </ul>
      </>
    )
  }

  //handles send back price
  const handleSendBackOrder = (e) => {
    e.preventDefault()

    setTotalLoading(true)

    //refference for databse Price calculation
    const orderRef = doc(db, "orders", totalState.id)

    //price ref for finalizing the price
    const priceref = doc(db, "priceCalculation", dataFromState.id)

    updateDoc(orderRef, {
      adminComment: adminComment,
      orderForAdmin: false,
      orderReviewFromAdmin: true,
    })
      .then(() => {
        updateDoc(priceref, dataFromState)
      })
      .then(() => {
        navigate("/unconfirmed-prices")
      })
      .catch((error) => {
        Notification("error", "Creation Error", error)
        setTotalLoading(false)
        console.log(error.message)
      })
  }

  //handles send back price
  const handleSendBackPrice = (e) => {
    e.preventDefault()

    setTotalLoading(true)

    //refference for databse Price calculation
    const priceref = doc(db, "priceCalculation", dataFromState.id)

    //notifications refference
    const notifRef = collection(db, "notifications")

    updateDoc(priceref, {
      adminComment: adminComment,
      sentBack: true,
    })
      .then(() => {
        addDoc(notifRef, {
          date: serverTimestamp(),
          desc: `Admin ${user.email} has sent back "${dataFromState.client}" for a product "${dataFromState.product.productName}"`,
          seen: false,
          type: "Price Sent Back",
          uid: dataFromState.user,
          userEmail: dataFromState.userEmail,
          productId: dataFromState.id,
          productName: dataFromState.product.productName,
          clientId: dataFromState.clientId,
          adminComment: adminComment,
        })
      })
      .then(() => {
        Notification("success", "Price Saved", "You have successfully saved the price")
        setTotalLoading(false)
      })
      .then(() => {
        navigate("/unconfirmed-prices")
      })
      .catch((error) => {
        Notification("error", "Creation Error", error)
        setTotalLoading(false)
        console.log(error.message)
      })
  }

  //price object
  const priceObject = {
    price: totalPrice,
    clientId: selectedClientId,
    client: selectedClientName,
    clientsProfit: clientsProfit,
    knifeCode: selectedKnifeCode,
    knifeId: selectedKnifeId,
    print: {
      cmykColors: cmykColors,
      cmykPercent: cmykPercent,
      pantoneColors: pantoneColors,
      pantonePercent: pantonePercent,
      coveringWCount: coveringWCount,
      coveringWPercent: coveringWPercent,
      varnishType: selectedVarnish,
      varnishPercent: varnishPercent,
      varnishUse: varnishUse,
      varnishId: selectedVarnishId,
      goldOrSilver: goldOrSilver,
      goldOrSilverPercent: goldOrSilverPercent,
      relief: selectedRelief,
      reliefId: selectedReliefId,
      foilCount: foilCount,
      foilColor: selectedFoilColor,
      foilPercent: foilPercent,
      foilId: selectedFoilId,
    },
    labelCount: labelCount,
    labelWeight: labelWeight,
    labelWidth: labelWidth,
    labelHeight: labelHeight,
    material: selectedMaterial,
    materialId: selectedMaterialId,
    formatWidth: formatWidth,
    numberOfColumns: numberOfColumns,
    timestamp: serverTimestamp(),
    date: {
      status: 0,
      lastEdit: serverTimestamp(),
      created: createdTime,
    },
    user: priceUser,
    userEmail: priceUserEmail,
    machine: selectedMachine,
    machineCosts: {
      worker: machineWorker,
      amortization: machineAmortization,
      electricity: machineElectricity,
    },
    product: {
      productName: productName,
      productFileUrl: adminProductFileLink,
    },
    aproved: false,
    changed: true,
    advanced: {
      sequentialProduction: secigaRazosana,
      howManyTimes: howManyTimes,
      extraProfit: extraProfitSlider,
      productionMachine: selectedProductionMachine,
      productionMachineId: selectedProductionMachineId,
      productionMachine2: selectedProductionMachine2,
      productionMachine2Id: selectedProductionMachine2Id,
      rowBalance: rowBalance,
      fixedPrice: fixedPrice,
      rastra: rastra,
      changableSpace: changableSpace,
    },
    userComment: userComment,
    dynamicPrice: dynamicPrice,
    dynamicFixedPrice: dynamicFixedPrice,
    totalFixedPrice: totalFixedPrice,
    adminComment: adminComment,
    startup: {
      newKnife: newKnife,
      knifePrice: knifePrice,
      newJob: newJob,
      plateObjects: plateObjects,
      knifeShape: knifeShape,
      newKnifeObject: newKnife
        ? {
            width: labelWidth,
            height: labelHeight,
            radius: newKnifeRadiuss,
            client: selectedClientName,
            clientId: selectedClientId,
            message: newKnifeMessage,
            shape: knifeShape,
            knifePrice: knifePrice,
            product: productName,
            user: user.email,
            machine: selectedMachine,
            fileLink: newKnifeFile,
            rows: numberOfColumns,
          }
        : {},
    },
  }

  const handleApprovePrice = (e) => {
    e.preventDefault()
    setTotalLoading(true)

    //refference for databse Price calculation
    const priceref = doc(db, "priceCalculation", dataFromState.id)
    //notifications refference
    const notifRef = collection(db, "notifications")

    updateDoc(priceref, {
      aproved: true,
      date: {
        status: 1,
        lastEdit: serverTimestamp(),
        created: createdTime,
      },
    })
      .then(() => {
        addDoc(notifRef, {
          date: serverTimestamp(),
          desc: `Admin ${user.email} has approved price for : "${dataFromState.product.productName}"`,
          seen: false,
          type: "Approved Price",
          uid: dataFromState.user,
          userEmail: dataFromState.userEmail,
          productId: dataFromState.id,
          productName: dataFromState.product.productName,
          clientId: dataFromState.clientId,
        })
      })
      .then(() => {
        Notification("success", "Price Updated", "You have successfully updated the price")
        setTotalLoading(false)
      })
      .then(() => {
        navigate("/unconfirmed-prices")
      })
      .catch((error) => {
        Notification("error", "Creation Error", error)
        setTotalLoading(false)
        console.log(error.message)
      })
  }

  //handles the price saving
  const handleSavePrice = (e) => {
    e.preventDefault()

    setTotalLoading(true)

    //refference for databse Price calculation
    const priceref = doc(db, "priceCalculation", dataFromState.id)

    //notifications refference
    const notifRef = collection(db, "notifications")

    updateDoc(priceref, priceObject)
      .then(() => {
        addDoc(notifRef, {
          date: serverTimestamp(),
          desc: `Admin ${user.email} has updated the price for client "${dataFromState.client}" for a product "${dataFromState.product.productName}"`,
          seen: false,
          type: "Price Updated",
          uid: dataFromState.user,
          userEmail: dataFromState.userEmail,
          productId: dataFromState.id,
          productName: dataFromState.product.productName,
          clientId: dataFromState.clientId,
          adminComment: adminComment,
          oldPrice: {
            price: dataFromState.price,
            clientId: dataFromState.clientId,
            client: dataFromState.client,
            clientsProfit: dataFromState.clientsProfit,
            knifeCode: dataFromState.knifeCode,
            knifeId: dataFromState.knifeId,
            cmykColors: dataFromState.print.cmykColors,
            cmykPercent: dataFromState.print.cmykPercent,
            pantoneColors: dataFromState.print.pantoneColors,
            pantonePercent: dataFromState.print.pantonePercent,
            coveringWCount: dataFromState.print.coveringWCount,
            coveringWPercent: dataFromState.print.coveringWPercent,
            varnishType: dataFromState.print.varnishType,
            varnishPercent: dataFromState.print.varnishPercent,
            varnishUse: dataFromState.print.varnishUse,
            varnishId: dataFromState.print.varnishId,
            goldOrSilver: dataFromState.print.goldOrSilver,
            goldOrSilverPercent: dataFromState.print.goldOrSilverPercent,
            relief: dataFromState.print.relief,
            reliefId: dataFromState.print.reliefId,
            foilCount: dataFromState.print.foilCount,
            foilColor: dataFromState.print.foilColor,
            foilPercent: dataFromState.print.foilPercent,
            foilId: dataFromState.print.foilId,
            labelCount: dataFromState.labelCount,
            labelWidth: dataFromState.labelWidth,
            labelHeight: dataFromState.labelHeight,
            material: dataFromState.material,
            materialId: dataFromState.materialId,
            formatWidth: dataFromState.formatWidth,
            numberOfColumns: dataFromState.numberOfColumns,
            machine: dataFromState.machine,
            productName: dataFromState.product.productName,
            productFileUrl: dataFromState.product.productFileUrl,
            sequentialProduction: dataFromState.advanced.sequentialProduction,
            howManyTimes: dataFromState.advanced.howManyTimes,
            extraProfit: dataFromState.advanced.extraProfit,
            productionMachine: dataFromState.advanced.productionMachine,
            productionMachineId: dataFromState.advanced.productionMachineId,
            productionMachine2: dataFromState.advanced.productionMachine2,
            productionMachine2Id: dataFromState.advanced.productionMachine2Id,
            rowBalance: dataFromState.advanced.rowBalance,
            fixedPrice: dataFromState.advanced.fixedPrice,
            rastra: dataFromState.advanced.rastra,
            totalFixedPrice: dataFromState.totalFixedPrice,
          },
          changedPrice: {
            price: totalPrice,
            clientId: selectedClientId,
            client: selectedClientName,
            clientsProfit: clientsProfit,
            knifeCode: selectedKnifeCode,
            knifeId: selectedKnifeId,
            cmykColors: cmykColors,
            cmykPercent: cmykPercent,
            pantoneColors: pantoneColors,
            pantonePercent: pantonePercent,
            coveringWCount: coveringWCount,
            coveringWPercent: coveringWPercent,
            varnishType: selectedVarnish,
            varnishPercent: varnishPercent,
            varnishUse: varnishUse,
            varnishId: selectedVarnishId,
            goldOrSilver: goldOrSilver,
            goldOrSilverPercent: goldOrSilverPercent,
            relief: selectedRelief,
            reliefId: selectedReliefId,
            foilCount: foilCount,
            foilColor: selectedFoilColor,
            foilPercent: foilPercent,
            foilId: selectedFoilId,
            labelCount: labelCount,
            labelWidth: labelWidth,
            labelHeight: labelHeight,
            material: selectedMaterial,
            materialId: selectedMaterialId,
            formatWidth: formatWidth,
            numberOfColumns: numberOfColumns,
            machine: selectedMachine,
            productName: productName,
            productFileUrl: adminProductFileLink,
            sequentialProduction: secigaRazosana,
            howManyTimes: howManyTimes,
            extraProfit: extraProfitSlider,
            productionMachine: selectedProductionMachine,
            productionMachineId: selectedProductionMachineId,
            productionMachine2: selectedProductionMachine2,
            productionMachine2Id: selectedProductionMachine2Id,
            rowBalance: rowBalance,
            fixedPrice: fixedPrice,
            rastra: rastra,
            totalFixedPrice: totalFixedPrice,
          },
        })
      })
      .then(() => {
        Notification("success", "Price Saved", "You have successfully saved the price")
        setTotalLoading(false)
      })
      .then(() => {
        navigate("/unconfirmed-prices")
      })
      .catch((error) => {
        Notification("error", "Creation Error", error)
        setTotalLoading(false)
        console.log(error.message)
      })
  }

  //handles the price saving
  const handleSaveOrder = (e) => {
    e.preventDefault()

    setTotalLoading(true)

    //refference for databse Price calculation
    const orderRef = doc(db, "orders", totalState.id)

    updateDoc(orderRef, {
      orderForAdmin: false,
      orderReviewFromAdmin: false,
      orderStatus: 1,
    })
      .then(() => {
        Notification("success", "Order Updated", "You have successfully updated the order")
        setTotalLoading(false)
      })
      .then(() => {
        navigate("/")
      })
      .catch((error) => {
        Notification("error", "Creation Error", error)
        setTotalLoading(false)
        console.log(error.message)
      })
  }

  // Declare variables
  // pirma rinda tabula
  let cenaMaterialamKopaEurM2 = 0

  // let secigaRazosana = 1;

  // otra rinda tabula
  let rinduSkaits = 1
  let skIzklajuma = 0

  //tresa rinda
  let krasuSk = 0
  let krasasPaterinsGM2 = 0
  let vidCenaKrasaiEurKg = 0

  let pieregulesanasLaiksMin = 0
  let pieregulesanasTM = 0
  let razosanasLaiksMin = 0

  let tirieTekosieMetri = 0
  let tirieM2 = 0
  let tehnologiskieZudumiM2 = 0

  let materialaIzmaksasEur = 0
  let visparejasIzmaksas = 0
  let VC = 0
  let elektriba = 0
  let krasasPaterinsEur = 0

  // Pieregulesanas laiks sadalijuma pa krasam min.
  let laiksMinCMYK = 10
  let laiksMinPantone = 11
  let pecapstrade1PieregulesanaM2 = 0

  //Pecapstrade 1, 2 un 3;
  let pecapstrade1VisparejasIzmaksas = 0
  let pecapstrade1RazosanasLaiksMin = 0
  let pecapstradeElektribaEur = 0

  // Produkcijas Komplektesana
  let produkcijasKomplektesanaElektribaEur = 0
  let produkcijasKomplektesanaVisparejasIzmaksas = 0
  let produkcijasKomplektesanaRazosanasLaiks = 0

  let produkcijasKomplektesana2ElektribaEur = 0
  let produkcijasKomplektesana2VisparejasIzmaksas = 0
  let produkcijasKomplektesana2RazosanasLaiks = 0

  let productionMaterialCosts = 0

  // transports
  let transportsCena = 0
  let transports = 0
  let tiraisSvarsKg = 0

  let pardosanasSummaEur = 0
  let kopejasIzmaksas = 0

  // main settings default
  let razosanasIzmaksas = 0
  let cenaPar1000uzlimemEur = 0

  //hotfoil or hotprint
  let hotprintProductionTimePerMin = 0
  let hotprintTotalCosts = 0
  let hotprintElectricity = 0
  let hotprintMaterialCosts = 0
  let hotprintAdjustmentM2 = 0
  let hotprintCost = 0

  const handleCalculate = (totalCount) => {
    /* cenaMaterialamKopaEurM2 = IF (folijasUznesumam1Settings= 1 ){
                                        materialEurM2 * folijasUznesumam1
                                } else {
                                      meterialaCena1
                                }
                                */

    cenaMaterialamKopaEurM2 = materialEurM2

    skIzklajuma = numberOfColumns * rinduSkaits

    let formataAugstums = Number(labelHeight) + Number(kniveSpaceBetweenRows)

    // tirieM2 = formataAugstums * formatWidth /1000000 * etiketesDaudzums / Sk. Izklajuma
    tirieM2 = (((formataAugstums * formatWidth) / 1000000) * totalCount) / skIzklajuma

    // Tīrie tekošie metri = tīrieM2 / Formāta platums * 1000
    tirieTekosieMetri = (tirieM2 / formatWidth) * 1000

    /* 
                                      if (document.getElementById("iespiedmasina1").value === 0) {
                                      pieregulesanasTM = 0;
                                } else {
                                      pieregulesanasTM =
                                        pieregulesanaPiekartosana +
                                        pieregulesanaCmykGatavieToni *
                                          cmykKrasuSkaits +
                                        pantoneSkaits *
                                          pieregulesanaPantone +
                                        sedzosoKrasuWSkaits *
                                          pieregulesanaPantone +
                                        zeltaVaiSudrabaKrasasSkaits *
                                          pieregulesanaPantone +
                                        (tirieTekosieMetri > 2000
                                          ? tirieTekosieMetri * 0.05
                                          : tirieTekosieMetri * 0.1) +
                                        (howManyTimes - 1) * 80 +
                                        (secigaRazosana - 1) * 60;
                                }
                                */
    if (machines === null) {
      pieregulesanasTM = 0
    } else {
      pieregulesanasTM =
        pieregulesanaPiekartosana +
        pieregulesanaCmykGatavieToni * cmykColors +
        pantoneColors * pieregulesanaPantone +
        coveringWCount * pieregulesanaPantone +
        goldOrSilver * pieregulesanaPantone +
        (tirieTekosieMetri > 2000 ? tirieTekosieMetri * 0.05 : tirieTekosieMetri * 0.1) +
        (howManyTimes - 1) * 80 +
        (secigaRazosana - 1) * 350
    }

    // tehnologiskieZudumiM2 = pieregulesanasTekosieMetri * formatWidth / 1000
    tehnologiskieZudumiM2 = (pieregulesanasTM * formatWidth) / 1000

    /*
                                Krāsas patēriņš g/m2 =
                                "cmykKrasuSkaits" * "krasuPaterinsCMYK" * "cmykParklajums%" + "pantoneParklajums%" *
                                IF("Pantone Skaits"= 0 tad 0 else 1) * "krasuPaterinsPantone" + 
                                IF("Laku Skaits" = 0 tad 0 else "lakasPārklājums%" * "meklē "Laku skaits" tabulā Laku veidi no "x pret parasto laku""
                                + "zeltaParklājums%" * "zeltaVaiSudrabaKrasasSk" * "krasuPaterinsZeltaKrasa" + "iespiedmasina2SietaParklajums%" * "iespiedmasina2Siets" * "krasuPaterinsSiets" 
                                + "iespiedmasina3SietaParklajums%" * "iespiedmasina3Siets" * "krasuPaterinsSiets" +
                                IF("sedzosoKrasuWSkaits"=0 tad 0 else "sedzošāKrāsaW%" * "sedzosoKrasuWSkaits" * Meklē "W izmantotā rasta lineatūra" iekš tabulas (sedzošās krāsas Wizmantotā vrastra veltņi))
                                */

    krasasPaterinsGM2 =
      //cmyk1
      cmykColors * krasuPaterinsCMYK * cmykPercent +
      // //cmyk2
      // Number(document.getElementById("cmykKrasuSkaits2").value) *
      //   krasuPaterinsCMYK *
      //   Number(document.getElementById("cmykParklajumsProcentos2").value) +
      // //cmyk3
      // Number(document.getElementById("cmykKrasuSkaits3").value) *
      //   krasuPaterinsCMYK *
      //   Number(document.getElementById("cmykParklajumsProcentos3").value) +
      //pantone1
      pantonePercent * (pantoneColors === 0 ? 0 : 1) * krasuPaterinsPantone +
      // extra line ar iekavam (pantonePercent * (pantoneColors === 0 ? 0 : 1) * krasuPaterinsPantone +
      //   //pantone 2
      //   Number(document.getElementById("pantoneParklajumsProcentos2").value) *
      //     (Number(document.getElementById("pantoneSkaits2").value) === 0 ? 0 : 1) *
      //     krasuPaterinsPantone +
      //   //pantone 3
      //   Number(document.getElementById("pantoneParklajumsProcentos3").value) *
      //     (Number(document.getElementById("pantoneSkaits3").value) === 0 ? 0 : 1) *
      //     krasuPaterinsPantone) +
      (varnishXpretp === 0 ? 0 : varnishPercent * varnishXpretp * krasuPaterinsLaka) +
      //zelta1
      goldOrSilverPercent * goldOrSilver * krasuPaterinsZeltaKrasa +
      // ar extra iekavinam(goldOrSilverPercent *
      //   goldOrSilver *
      //   krasuPaterinsZeltaKrasa +
      //   //zelta2
      //   Number(document.getElementById("zeltaParklajumsProcentos2").value) *
      //     Number(document.getElementById("zeltaVaiSudrabaKrasasSkaits2").value) *
      //     krasuPaterinsZeltaKrasa +
      //   //zelta3
      //   Number(document.getElementById("zeltaParklajumsProcentos3").value) *
      //     Number(document.getElementById("zeltaVaiSudrabaKrasasSkaits3").value) *
      //     krasuPaterinsZeltaKrasa) +
      (coveringWCount === 0 ? 0 : coveringWPercent * coveringWCount) *
        // + Number(document.getElementById("sedzosoKrasuWSkaitsProcentos2").value) *
        //   Number(document.getElementById("sedzosoKrasuWSkaits2").value) +
        // Number(document.getElementById("sedzosoKrasuWSkaitsProcentos3").value) *
        //   Number(document.getElementById("sedzosoKrasuWSkaits3").value)
        rastra
    krasasPaterinsGM2 = krasasPaterinsGM2.toFixed(2)
    krasasPaterinsGM2 = Number(krasasPaterinsGM2)

    /*
                                    1000 / krasasPaterinsGM2 
                                    * (cmykParklajumsProcentos * cmykKrasuSkaits * krasuPaterinsCMYK * krasuCenaEurKgCMYK
                                        + pantoneParklajumsProcentos * if(pantoneSkaits) * krasuPaterinsPantone * krasuCenaEurKgPantone
                                    + if(lakuSkaits, 0 else lakasParklajumsProcentos * lakuSkaitsVLOOKUP * krasuPaterinsLaka * krasuCenaEurKgLaka )
                                    + zeltaParklajumsProcentos * zeltaVaiSudrabaKrasasSk * krasuPaterinsZeltaKrasa * krasuCenaEurKgZeltsUnSudrabs
                                    + iespiedmasina2SietaParklajumsProcentos * iespiedmasina2Siets * krasuPaterinsSiets * krasuCenaEurKgSietaKrasaCena
                                    + iespiedmasina23ietaParklajumsProcentos * iespiedmasina3Siets * krasuPaterinsSiets * krasuCenaEurKgSietaKrasaCena
                                    + if(sedzosoKrasuWSkaits = 0 tad 0 else sedzosaKrasaWProcentos * krasuCenaEurKgSedzosaKrasaW * sedzosoKrasuWSkaits * "meklē wIzmantotaRastraLiantūru iekš Sedzoso Krasu W izmantoto" ) /1000
                            
                                  */

    vidCenaKrasaiEurKg =
      ((1000 / krasasPaterinsGM2) *
        //cmyk1
        (cmykPercent * cmykColors * krasuPaterinsCMYK * krasuCenaEurKgCMYK +
          // //cmyk2
          // Number(document.getElementById("cmykParklajumsProcentos2").value) *
          //   Number(document.getElementById("cmykKrasuSkaits2").value) *
          //   krasuPaterinsCMYK *
          //   krasuCenaEurKgCMYK +
          // //cmyk3
          // Number(document.getElementById("cmykParklajumsProcentos3").value) *
          //   Number(document.getElementById("cmykKrasuSkaits3").value) *
          //   krasuPaterinsCMYK *
          //   krasuCenaEurKgCMYK +
          //pantone 1
          pantonePercent *
            (pantoneColors === 0 ? 0 : 1) *
            krasuPaterinsPantone *
            krasuCenaEurKgPantone +
          // //pantone 2
          // Number(document.getElementById("pantoneParklajumsProcentos2").value) *
          //   (Number(document.getElementById("pantoneSkaits2").value) === 0 ? 0 : 1) *
          //   krasuPaterinsPantone *
          //   krasuCenaEurKgPantone +
          // //pantone 3
          // Number(document.getElementById("pantoneParklajumsProcentos3").value) *
          //   (Number(document.getElementById("pantoneSkaits3").value) === 0 ? 0 : 1) *
          //   krasuPaterinsPantone *
          //   krasuCenaEurKgPantone) +
          (varnishUse === 0
            ? 0
            : varnishPercent * varnishXpretp * krasuPaterinsLaka * krasuCenaEurKgLaka) +
          //zelta1
          goldOrSilverPercent *
            goldOrSilver *
            krasuPaterinsZeltaKrasa *
            krasuCenaEurKgZeltsUnSudrabs +
          // //zelta2
          // Number(document.getElementById("zeltaParklajumsProcentos2").value) *
          //   Number(document.getElementById("zeltaVaiSudrabaKrasasSkaits2").value) *
          //   krasuPaterinsZeltaKrasa *
          //   krasuCenaEurKgZeltsUnSudrabs +
          // //zelta3
          // Number(document.getElementById("zeltaParklajumsProcentos3").value) *
          //   Number(document.getElementById("zeltaVaiSudrabaKrasasSkaits3").value) *
          //   krasuPaterinsZeltaKrasa *
          //   krasuCenaEurKgZeltsUnSudrabs
          (coveringWCount === 0 ? 0 : coveringWPercent * krasuCenaEurKgSedzosaKrasaW) *
            // +
            //   Number(document.getElementById("sedzosoKrasuWSkaitsProcentos2").value) *
            //     krasuCenaEurKgSedzosaKrasaW +
            //   Number(document.getElementById("sedzosoKrasuWSkaitsProcentos3").value) *
            //     krasuCenaEurKgSedzosaKrasaW
            coveringWCount *
            rastra)) /
      1000
    vidCenaKrasaiEurKg = vidCenaKrasaiEurKg.toFixed(2)
    vidCenaKrasaiEurKg = Number(vidCenaKrasaiEurKg)

    // krasasPaterinsEur = if (krasas paterins g/m2 = 0) tad 0 ; else = (tirieM2 + tehnologiskieZudumiM2 * 0.5) * krasas paterins g/m2 / 1000 * Vide.cena krasai EUR/kg
    if (krasasPaterinsGM2 === 0) {
      krasasPaterinsEur = 0
    } else {
      krasasPaterinsEur =
        (((tirieM2 + tehnologiskieZudumiM2 * 0.5) * krasasPaterinsGM2) / 1000) * vidCenaKrasaiEurKg
    }
    krasasPaterinsEur = krasasPaterinsEur.toFixed(2)
    krasasPaterinsEur = Number(krasasPaterinsEur)

    /* Krāsu skaits = 
                                CMYK Krāsu skaits 
                                + Pantone Skaits 
                                + Zelta vai sudraba krāsu skaits
                                + iespiedmasina2Siets
                                + iespiedmasina3Siets
                                + Sedzošo Krāsu W skaits 
                                */
    krasuSk = cmykColors + pantoneColors + goldOrSilver + coveringWCount

    // Ražošanas laiks min = if(iespiedmasina1 = 0, tad 0 else{ Tīrie tekošie metri / Darba ātrums m/ min} )
    if (machines === null) {
      razosanasLaiksMin = 0
    } else {
      razosanasLaiksMin = tirieTekosieMetri / machineSpeed
      razosanasLaiksMin = razosanasLaiksMin.toFixed(2)
      razosanasLaiksMin = Number(razosanasLaiksMin)
    }

    /* pieregulēšanas laiks minūtē = if ( iespiedmasina1 = -, tad 0) else {
                                      CMYK krāsu skaits * pieregulēšanas laiks sadalajījumā a krāsām min - CMYK
                                      + Pantone skaits * pieregulēšanas laiks sadalajījumā a krāsām min - Pantone
                                      + Sedzošo krāsu W skaits * pieregulēšanas laiks sadalajījumā a krāsām min - Pantone
                                      + Zelta vai sudraba krāsu skaits * pieregulēšanas laiks sadalajījumā a krāsām min - CMYK
                                      + 20
                                      - if( Krāsu skaits > 6, tad { 
                                        (Krāsu skaits - 6) * 20 * 0.4
                                  } else {
                                        0
                                    })
                                  + (Dalita razosana, cik reizes darbs iet caur masinu - 1) * 60
                                  + (Secīgā ražošana(darbus skaits) - 1)
                                  * ((CMYK krāsu skaits * pieregulēšanas laiks sadalajījumā a krāsām min - CMYK
                                      + Pantone skaits * pieregulēšanas laiks sadalajījumā a krāsām min - Pantone
                                      + Sedzošo krāsu W skaits * pieregulēšanas laiks sadalajījumā a krāsām min - Pantone
                                      + Zelta vai sudraba krāsu skaits * pieregulēšanas laiks sadalajījumā a krāsām min - CMYK) * 0.6
                                  - if(Krāsu skaits > 6,  tad { 
                                        (Krāsu skaits - 6) * 20 * 0.4
                                   }else {
                                         0
                                   })
                              )
                            }
                                */
    if (machines === null) {
      pieregulesanasLaiksMin = 0
    } else {
      pieregulesanasLaiksMin = Math.round(
        cmykColors * laiksMinCMYK +
          pantoneColors * laiksMinPantone +
          coveringWCount * laiksMinPantone +
          goldOrSilver * laiksMinCMYK +
          20 -
          (krasuSk > 6 ? (krasuSk - 6) * 20 * 0.4 : 0) +
          (howManyTimes - 1) * 60 +
          (secigaRazosana - 1) *
            ((cmykColors * laiksMinCMYK +
              pantoneColors * laiksMinPantone +
              coveringWCount * laiksMinPantone +
              goldOrSilver * laiksMinCMYK) *
              0.6 -
              (krasuSk > 6 ? (krasuSk - 6) * 20 * 0.4 : 0))
      )
    }

    // pecapstrade1PieregulesanaM2 = (mekle no tabulas pieregulesanas laiks sadalijuma pa krasam pier.t.m.) * Formata platums / 1000
    pecapstrade1PieregulesanaM2 = (reliefRunningMeters * formatWidth) / 1000

    // custom calculation for relief
    if (selectedReliefUse === 1) {
      productionMaterialCosts = materialEurM2 * (pecapstrade1PieregulesanaM2 + tirieM2)
    } else {
      productionMaterialCosts = 0
    }

    // pecapstrade1RazosanasLaiksMin = if (procesi = 0) tad 0 ; else ; tirieTekosieMetri / pecapstade1TekosieMetriMinute
    if (reliefRunningMeters === 0) {
      pecapstrade1RazosanasLaiksMin = 0
    } else {
      pecapstrade1RazosanasLaiksMin = tirieTekosieMetri / reliefMeters
    }

    //  Produkcijas komplektēšanas 2 ražošanas laiks = if (meklē dropdown un ir 0), tad = 0 ; else Tīrie tekošiem metri / (dropdown izvēlētais value (t.m./min.))
    produkcijasKomplektesana2RazosanasLaiks = tirieTekosieMetri / productionRunningMetersMin2

    // Produkcijas komplektēšanas ražošanas laiks = if (meklē dropdown un ir 0), tad = 0 ; else Tīrie tekošiem metri / (dropdown izvēlētais value (t.m./min.))
    produkcijasKomplektesanaRazosanasLaiks = tirieTekosieMetri / productionRunningMetersMin

    //elektriba = (pieregulesanas laiks min. + razosanas laiks min.) / 60 * 15 * 0.34
    elektriba = ((pieregulesanasLaiksMin + razosanasLaiksMin) / 60) * 15 * 0.34
    elektriba = elektriba.toFixed(2)
    elektriba = Number(elektriba)

    //visparejasIzmaksas = (mekle iespiedmasinu 1 un tas visp. izmaksas) * (pieregulesanas Laiks Min  + razosanasLaiksMin.) / 60
    visparejasIzmaksas =
      ((machineElectricity + machineWorker + machineAmortization) *
        (pieregulesanasLaiksMin + razosanasLaiksMin)) /
      60
    visparejasIzmaksas = visparejasIzmaksas.toFixed(2)
    visparejasIzmaksas = Number(visparejasIzmaksas)

    // materialaIzmaksasEur = (tirieM2  + tehnologiskieZudumiM2 ) * cenaMaterialamKopaEurM2 + krasasPaterinsEur
    materialaIzmaksasEur =
      (tirieM2 + tehnologiskieZudumiM2) * cenaMaterialamKopaEurM2 + krasasPaterinsEur
    materialaIzmaksasEur = materialaIzmaksasEur.toFixed(2)
    materialaIzmaksasEur = Number(materialaIzmaksasEur)

    // VC = (MaterialaIzmaksasEur +  VisparejasIzmaksas) * (1 + Razosanas rentabilitate) * 0,07
    VC = (materialaIzmaksasEur + visparejasIzmaksas) * (1 + Number(clientsProfit / 100)) * 0.07
    VC = VC.toFixed(2)
    VC = Number(VC)

    // updates tirais svars from input field
    tiraisSvarsKg = ((materialGM2 + krasasPaterinsGM2 * 0.3) / 1000) * tirieM2

    tiraisSvarsKg = Number(tiraisSvarsKg.toFixed(2))

    //transports = (Mekle uz kurieni un pievieno cenu) * tiraisSvarsKg
    transports = transportsCena * tiraisSvarsKg

    // produkcijasKomplektesanaElektribaEur = (Pieregulesanas Laiks min) /60 * 15 * 0.12
    produkcijasKomplektesana2ElektribaEur = (productionTimePerMinute2 / 60) * 15 * 0.12

    // produkcijasKomplektesanaElektribaEur = (Pieregulesanas Laiks min) /60 * 15 * 0.12
    produkcijasKomplektesanaElektribaEur = (productionTimePerMinute / 60) * 15 * 0.12

    // produkcijasKomplektesana2VisparejasIzmaksas = (mekle no materialu lapas cenas EUR m2) * (produkcijas komplektesanas 2 Pieregulesana Min + produkcijas komplektesanas 2 Razosanas Laiks) /60
    produkcijasKomplektesana2VisparejasIzmaksas =
      (productionCosts2 * (productionTimePerMinute2 + produkcijasKomplektesana2RazosanasLaiks)) / 60

    // produkcijasKomplektesanaVisparejasIzmaksas = (mekle no materialu lapas cenas EUR m2) * (produkcijas komplektesanas Pieregulesana Min + produkcijas komplektesanas Razosanas Laiks) /60
    produkcijasKomplektesanaVisparejasIzmaksas =
      (productionCosts * (productionTimePerMinute + produkcijasKomplektesanaRazosanasLaiks)) / 60

    // pecapstradeElektribaEur = pieregulesanas laiks min / 60 * 20 * 0.15
    pecapstradeElektribaEur = (reliefTimePerMin / 60) * 20 * 0.15
    pecapstradeElektribaEur = pecapstradeElektribaEur.toFixed(2)
    pecapstradeElektribaEur = Number(pecapstradeElektribaEur)

    // pecapstrade1VisparejasIzmaksas = (mekle ievadi no saraksta Iespiedmasinas visp.izmaksas EUR/h) * (Pieregulesanas Laiks Min 1 + Razosanas laiks min 1 ) / 60
    pecapstrade1VisparejasIzmaksas = (reliefTimePerMin + pecapstrade1RazosanasLaiksMin) / 60

    // razosanas izmaksas = materiala izmaksas eur + visparejas izmaksas + VC  + elektriba
    razosanasIzmaksas = materialaIzmaksasEur + visparejasIzmaksas + VC + elektriba

    if (foilCount > 0) {
      //hotfoil production time per min
      hotprintProductionTimePerMin = tirieTekosieMetri / hotprintMeterPerMin
      hotprintProductionTimePerMin = Math.floor(hotprintProductionTimePerMin)

      //hotprintTotalCosts
      hotprintTotalCosts =
        (hotprintCostsPerH * (hotprintAdjustmentTimeMin + hotprintProductionTimePerMin)) / 60

      //hotprintEelectricity
      hotprintElectricity = (hotprintAdjustmentTimeMin / 60) * 20 * 0.15

      //hotprint adjustment m2
      hotprintAdjustmentM2 = (hotprintAdjustmentRunningMeters * formatWidth) / 1000

      //hotprintMaterial
      hotprintMaterialCosts = foilCosts * (hotprintAdjustmentM2 + tirieM2) * foilPercent

      //hotprint total costs
      hotprintCost = hotprintMaterialCosts + hotprintElectricity + hotprintTotalCosts
    } else {
      hotprintCost = 0
    }

    /* Kopejas izmaksas = razosanas izmaksas 
                                + 2. iespiedmasina ( Visparejas izmaksas eur)
                                + 3. iespiedmasina (Visparejas izmaksas eur)
                                + 2. iespiedmasina (Eletriba Eur) 
                                + 3. iespiedmasina (Elektriba Eur) 
                                + 2. iespiedmasina (Materiala izmaskas EUR) 
                                + 3. iespiedmasina (Materiala izmaksas EUR) 
                            
                                + 1. Pecapstrade (Visparejas izmaksas) 
                                + 2. Pecapstrade (Visparejas izmaksas) 
                                + 3. Pecapstrade (Visparejas izmaksas)
                                + 1. Pecapstrade (Elektriba Eur) 
                                + 2. Pecapstrade (Elektriba Eur) 
                                + 3. Pecapstrade (Elektriba Eur) 
                                + 1. Pecapstrade (Materiala izmaksas EUR) 
                                + 2. Pecapstrade (Materiala izmaksas EUR) 
                                + 3. Pecapstrade (Materiala izmaksas EUR) 
                                
                                + produkcijasKomplektesanaVisparejasIzmaksas (Visparejas izmaksas) 
                                + produkcijasKomplektesanaElektribaEur (Visparejas izmaksas) 
                                + produkcijasKomplektesana2VisparejasIzmaksas (Elektriba Eur) 
                                + produkcijasKomplektesana2ElektribaEur (Elektriba Eur) 
                            
                                + Transports
                                */
    kopejasIzmaksas =
      razosanasIzmaksas +
      hotprintCost +
      pecapstrade1VisparejasIzmaksas +
      productionMaterialCosts +
      pecapstradeElektribaEur +
      produkcijasKomplektesanaVisparejasIzmaksas +
      produkcijasKomplektesana2VisparejasIzmaksas +
      produkcijasKomplektesanaElektribaEur +
      produkcijasKomplektesana2ElektribaEur +
      transports

    pardosanasSummaEur =
      kopejasIzmaksas *
      (1 +
        Number(clientsProfit / 100) +
        Number(extraProfitSlider / 100) +
        Number(userExtraPercent / 100))

    //cena par 1000 uzlimem eur
    // = pardosanas summa / etiketes daudzums * 1000

    cenaPar1000uzlimemEur = (pardosanasSummaEur / Number(totalCount)) * 1000

    cenaPar1000uzlimemEur = cenaPar1000uzlimemEur.toFixed(2)
    cenaPar1000uzlimemEur = Number(cenaPar1000uzlimemEur)

    setUpdatePriceButton(false)
    return { cenaPar1000uzlimemEur, tiraisSvarsKg }
  }

  //runs render on on start
  useEffect(() => {
    //checks for dynamic fixed price if the weight has been calculated
    const isAllZero = dynamicFixedPrice.some((obj) => obj.labelWeight === 0)

    if (rowBalance < 0 || rowBalance > 10) {
      setTooltipRowBalance(true)
    } else {
      setTooltipRowBalance(false)
    }
    if (
      isNaN(totalPrice) ||
      totalPrice === 0 ||
      labelCount === 0 ||
      productName === null ||
      rowBalance < -5 ||
      isAllZero
    ) {
      setSaveButtonDisabled(true)
    } else {
      setSaveButtonDisabled(false)
    }
  }, [totalPrice, labelCount, productName, rowBalance, dynamicFixedPrice])

  //Tab data for viva
  const vivaTab = (
    <>
      <Row
        style={{
          paddingRight: 45,
          paddingLeft: 45,
          paddingBottom: 45,
        }}
        align="middle"
        gutter={[2, 5]}>
        <Col span={24}>
          <Space space="middle">
            <Tooltip
              placement="bottomLeft"
              title="This tells how many times a single job will go trought the machine (max. 3 times). Each time it goes trough, it add's extra machine-points, but in exchange the price will grow.">
              <InfoCircleOutlined />
            </Tooltip>
            <Text>How many times job goes trought ?</Text>
            <InputNumber
              value={howManyTimes}
              onChange={(value) => setHowManyTimes(value)}
              min={1}
              max={3}
              defaultValue={1}
            />
          </Space>
        </Col>
        <Col span={24}>
          <Space>
            <Tooltip
              placement="bottomLeft"
              title="This function allows to make the same job multiple times while lowering costs">
              <InfoCircleOutlined />
            </Tooltip>
            <Text>Sequential production</Text>
            <InputNumber value={secigaRazosana} onChange={setSecigaRazosa} />
          </Space>
        </Col>
        <Col span={24}>
          <Space>
            <Tooltip
              placement="bottomLeft"
              title="Machines-points are used to determine how many stations are left per one print. Maximum number of foils per print : 1">
              <InfoCircleOutlined />
            </Tooltip>
            <Text> Points Remaining : </Text>
            <Text style={pointsRemaining >= 1 ? { color: "#1890ff" } : { color: "#f5222d" }}>
              {" "}
              {pointsRemaining}
            </Text>
          </Space>
        </Col>
        <Divider></Divider>
        <Col span={6}>
          <Space>
            <Tooltip placement="bottom" title="How much process colors cmyk needed">
              <InfoCircleFilled />
            </Tooltip>
            <Text>CMYK</Text>
          </Space>
        </Col>
        <Col span={18}>
          <InputNumber
            value={cmykColors}
            max={pointsRemaining + cmykColors}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setCmykColors(value)}
            placeholder="0"
          />
        </Col>
        {/* <Col span={7}>
                 <InputNumber
                    value={cmykPercent * 100}
                    style={{ width: "100%" }}
                    onChange={(value) => setCmykPercent(value / 100)}
                    step={5}
                    min={0}
                    max={100}
                    placeholder={0}
                    addonAfter="%"
                 />
              </Col> */}
        <Col span={6}>
          <Text>Pantone</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={pantoneColors}
            max={pointsRemaining + pantoneColors}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setPantoneColors(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={pantonePercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setPantonePercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>White</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={coveringWCount}
            max={pointsRemaining + coveringWCount}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setCoveringWCount(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={coveringWPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setCoveringWPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>Varnish</Text>
        </Col>
        <Col span={18}>
          <Select
            disabled={pointsRemaining === 0 ? (varnishUse === 0 ? true : false) : false}
            value={varnishType}
            onChange={handleVarnish}
            showSearch
            style={{ width: "100%" }}
            placeholder="none"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {varnish &&
              varnish.map((varnish, id) => (
                <Option
                  id={varnish.id}
                  key={id}
                  costs={varnish.costs}
                  xpretp={varnish.xpretp}
                  value={varnish.type}
                  used={varnish.used}>
                  {varnish.type}
                </Option>
              ))}
          </Select>
        </Col>
        {/* <Col span={7}>
                 <InputNumber
                    value={varnishPercent * 100}
                    style={{ width: "100%" }}
                    onChange={(value) => setVarnishPercent(value / 100)}
                    step={5}
                    min={0}
                    max={100}
                    placeholder={0}
                    addonAfter="%"
                 />
              </Col> */}
        <Col span={6}>
          <Text>Silver/Gold</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={goldOrSilver}
            max={pointsRemaining + goldOrSilver}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setGoldOrSilver(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={goldOrSilverPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setGoldOrSilverPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>Relief</Text>
        </Col>
        <Col span={18}>
          <Select
            disabled={pointsRemaining === 0 ? (selectedReliefUse === 0 ? true : false) : false}
            value={selectedReliefValue}
            onChange={handleRelief}
            showSearch
            style={{ width: "100%" }}
            placeholder="no"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {relief &&
              relief.map((relief, id) => (
                <Option
                  id={relief.id}
                  key={id}
                  meters={relief.meters}
                  runningMeters={relief.runningMeters}
                  timePerMin={relief.timePerMin}
                  value={relief.value}>
                  {relief.tag}
                </Option>
              ))}
          </Select>
        </Col>
        <Col span={6}>
          <Text>Foil</Text>
        </Col>
        <Col span={5}>
          <InputNumber
            value={foilCount}
            max={pointsRemaining === 0 ? (foilCount === 1 ? 1 : 0) : 1}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setFoilCount(value)}
            placeholder="0"
          />
        </Col>
        <Col span={6}>
          <Select
            value={foilColor}
            onChange={handleFoil}
            showSearch
            style={{ width: "100%" }}
            placeholder="none"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {foil &&
              foil.map((foil, id) => (
                <Option id={foil.id} key={id} costs={foil.costs} value={foil.color}>
                  {foil.color}
                </Option>
              ))}
          </Select>
        </Col>
        <Col span={7}>
          <InputNumber
            value={foilPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setFoilPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Divider orientation="middle"></Divider>
        <Col span={24}>
          <Space direction="vertical" size={0} style={{ display: "flex" }}>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Pantone</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(pantonePercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Covering White</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(coveringWPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Silver/Gold</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(goldOrSilverPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Foil</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(foilPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
          </Space>
        </Col>
      </Row>
    </>
  )
  const arsomaTab = (
    <>
      <Row
        style={{
          paddingRight: 45,
          paddingLeft: 45,
          paddingBottom: 45,
        }}
        align="middle"
        gutter={[2, 5]}>
        <Col span={24}>
          <Space>
            <Tooltip
              placement="bottomLeft"
              title="This function allows to make the same job multiple times while lowering costs">
              <InfoCircleOutlined />
            </Tooltip>
            <Text>Sequential production</Text>
            <InputNumber value={secigaRazosana} onChange={setSecigaRazosa} />
          </Space>
        </Col>
        <Col span={24}>
          <Space>
            <Tooltip
              placement="bottomLeft"
              title="Machines-points are used to determine how many stations are left per one print. Maximum number of foils per print : 1">
              <InfoCircleOutlined />
            </Tooltip>
            <Text> Points Remaining : </Text>
            <Text style={pointsRemaining >= 1 ? { color: "#1890ff" } : { color: "#f5222d" }}>
              {pointsRemaining}
            </Text>
          </Space>
        </Col>
        <Divider></Divider>

        <Col span={6}>
          <Space>
            <Tooltip placement="bottom" title="How much process colors cmyk needed">
              <InfoCircleFilled />
            </Tooltip>
            <Text>CMYK</Text>
          </Space>
        </Col>
        <Col span={18}>
          <InputNumber
            value={cmykColors}
            max={pointsRemaining + cmykColors}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setCmykColors(value)}
            placeholder="0"
          />
        </Col>
        {/* <Col span={7}>
                 <InputNumber
                    value={cmykPercent * 100}
                    style={{ width: "100%" }}
                    onChange={(value) => setCmykPercent(value / 100)}
                    step={5}
                    min={0}
                    max={100}
                    placeholder={0}
                    addonAfter="%"
                 />
              </Col> */}
        <Col span={6}>
          <Text>Pantone</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={pantoneColors}
            max={pointsRemaining + pantoneColors}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setPantoneColors(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={pantonePercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setPantonePercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>White</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={coveringWCount}
            max={pointsRemaining + coveringWCount}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setCoveringWCount(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={coveringWPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setCoveringWPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>Varnish</Text>
        </Col>
        <Col span={18}>
          <Select
            disabled={pointsRemaining === 0 ? (varnishUse === 0 ? true : false) : false}
            value={varnishType}
            onChange={handleVarnish}
            showSearch
            style={{ width: "100%" }}
            placeholder="none"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {varnish &&
              varnish.map((varnish, id) => (
                <Option
                  id={varnish.id}
                  key={id}
                  costs={varnish.costs}
                  xpretp={varnish.xpretp}
                  value={varnish.type}
                  used={varnish.used}>
                  {varnish.type}
                </Option>
              ))}
          </Select>
        </Col>
        {/* <Col span={7}>
                 <InputNumber
                    value={varnishPercent * 100}
                    style={{ width: "100%" }}
                    onChange={(value) => setVarnishPercent(value / 100)}
                    step={5}
                    min={0}
                    max={100}
                    placeholder={0}
                    addonAfter="%"
                 />
              </Col> */}
        <Col span={6}>
          <Text>Silver/Gold</Text>
        </Col>
        <Col span={11}>
          <InputNumber
            value={goldOrSilver}
            max={pointsRemaining + goldOrSilver}
            min={0}
            style={{ width: "100%" }}
            onChange={(value) => setGoldOrSilver(value)}
            placeholder="0"
          />
        </Col>
        <Col span={7}>
          <InputNumber
            value={goldOrSilverPercent * 100}
            style={{ width: "100%" }}
            onChange={(value) => setGoldOrSilverPercent(value / 100)}
            step={5}
            min={0}
            max={100}
            placeholder={0}
            addonAfter="%"
          />
        </Col>
        <Col span={6}>
          <Text>Relief</Text>
        </Col>
        <Col span={18}>
          <Select
            disabled={pointsRemaining === 0 ? (selectedReliefUse === 0 ? true : false) : false}
            value={selectedReliefValue}
            onChange={handleRelief}
            showSearch
            style={{ width: "100%" }}
            placeholder="no"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            filterSort={(optionA, optionB) =>
              optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
            }>
            {relief &&
              relief.map((relief, id) => (
                <Option
                  id={relief.id}
                  key={id}
                  meters={relief.meters}
                  runningMeters={relief.runningMeters}
                  timePerMin={relief.timePerMin}
                  value={relief.value}>
                  {relief.tag}
                </Option>
              ))}
          </Select>
        </Col>
        {/* <Col span={6}>
               <Text>Foil</Text>
            </Col>
            <Col span={5}>
               <InputNumber
                  value={foilCount}
                  max={pointsRemaining === 0 ? (foilCount === 1 ? 1 : 0) : 1}
                  min={0}
                  style={{ width: "100%" }}
                  onChange={(value) => setFoilCount(value)}
                  placeholder="0"
               />
            </Col>
            <Col span={6}>
               <Select
                  value={foilColor}
                  
                  onChange={handleFoil}
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="none"
                  optionFilterProp="children"
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  filterSort={(optionA, optionB) => optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())}
               >
                  {foil &&
                     foil.map((foil, id) => (
                        <Option id={foil.id} key={id} costs={foil.costs} value={foil.color}>
                           {foil.color}
                        </Option>
                     ))}
               </Select>
            </Col>
            <Col span={7}>
               <InputNumber
                  value={foilPercent * 100}
                  style={{ width: "100%" }}
                  onChange={(value) => setFoilPercent(value / 100)}
                  step={5}
                  min={0}
                  max={100}
                  placeholder={0}
                  addonAfter="%"
               />
            </Col> */}
        <Divider orientation="middle"></Divider>
        <Col span={24}>
          <Space direction="vertical" size={0} style={{ display: "flex" }}>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Pantone</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(pantonePercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Covering White</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(coveringWPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Silver/Gold</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(goldOrSilverPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
            <Space align="center" style={{ display: "flex", justifyContent: "space-between" }}>
              <Text>Foil</Text>
              <Progress
                steps={10}
                percent={Number.parseFloat(foilPercent * 100).toFixed(0)}
                status="active"
              />
            </Space>
          </Space>
        </Col>
      </Row>
    </>
  )

  //returns the correct button for sending further
  const returnCorrectButton = () => {
    if (wasSentFromDesigner) {
      return (
        <>
          <Popconfirm
            disabled={saveButtonDisabled}
            title="Are you sure to you want to save?"
            onConfirm={handleSendBackOrder}
            okText="Yes"
            cancelText="No">
            <Button loading={totalLoading} disabled={saveButtonDisabled} type="default" block>
              Comment Order
            </Button>
          </Popconfirm>

          <Popconfirm
            disabled={saveButtonDisabled}
            title="Are you sure to you want to save?"
            onConfirm={handleSaveOrder}
            okText="Yes"
            cancelText="No">
            <Button loading={totalLoading} disabled={saveButtonDisabled} type="default" block>
              Approve Order
            </Button>
          </Popconfirm>
        </>
      )
    } else {
      //returns this if its a normal order
      return (
        <>
          <Popconfirm
            disabled={adminComment === null ? true : false}
            title="Are you sure to you want send back the price? This wont affect any change that has been made by you (admin) and only will send back the price with the admin comment."
            onConfirm={handleSendBackPrice}
            okText="Yes"
            cancelText="No">
            <Button
              loading={totalLoading}
              disabled={adminComment === null ? true : false}
              danger
              type="primary"
              block>
              Comment & Send Back
            </Button>
          </Popconfirm>
          <Popconfirm
            disabled={updatePriceButton}
            title="Are you sure to you want to save? This will update the price and add the comment you have written."
            onConfirm={handleSavePrice}
            okText="Yes"
            cancelText="No">
            <Button
              loading={totalLoading}
              disabled={updatePriceButton || saveButtonDisabled}
              type="default"
              block>
              Update Price
            </Button>
          </Popconfirm>
          <Popconfirm
            disabled={disabledApproveButton}
            title="Are you sure to you want to approve?"
            onConfirm={handleApprovePrice}
            okText="Yes"
            cancelText="No">
            <Button loading={totalLoading} disabled={disabledApproveButton} type="default" block>
              Approve price
            </Button>
          </Popconfirm>
        </>
      )
    }
  }

  if (globalLoading) {
    return (
      <>
        <Space>
          <Title level={3}>
            <RollbackOutlined />
            <Divider type="vertical" /> Re-Calcaulate{" "}
          </Title>
        </Space>
        <div className="spinner-container-custom">
          <Spin tip="Loading Data for Price" size="large" />
        </div>
      </>
    )
  }

  return (
    <>
      <Space>
        <Title level={3}>
          <RollbackOutlined />
          <Divider type="vertical" /> Re-Calcaulate{" "}
        </Title>
        <Divider type="vertical" />
        <Text>New job?</Text>
        <Select
          size="small"
          value={newJob ? "Yes" : "No"}
          style={{
            width: 120,
          }}
          options={[
            {
              value: false,
              label: "No",
            },
            {
              value: true,
              label: "Yes",
            },
          ]}
          onChange={handleNewJob}
        />
      </Space>

      <>
        <Row>
          <Col
            style={{
              paddingRight: 15,
              paddingLeft: 15,
              background: "white",
              borderRadius: "3px",
            }}
            className="gutter-row"
            span={7}>
            <Divider orientation="middle">Main settings</Divider>
            <Row style={{ paddingBottom: "20px" }} align="middle" gutter={[2, 5]}>
              <Col span={10}>
                <Text>
                  Machine{" "}
                  {selectedMachine === null ? "" : <CheckCircleFilled style={{ color: "green" }} />}
                </Text>
              </Col>
              <Col span={14}>
                <Select
                  value={selectedMachine}
                  onChange={handleMachine}
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Machine"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  }>
                  {machines &&
                    machines.map((machine, id) => (
                      <Option
                        id={machine.id}
                        key={id}
                        alsm={machine.alsm}
                        worker={machine.costs.worker}
                        electricity={machine.costs.electricity}
                        amortization={machine.costs.amortization}
                        speed={machine.speed}
                        stations={machine.stations}
                        value={machine.machine}>
                        {machine.machine}
                      </Option>
                    ))}
                </Select>
              </Col>

              <Col span={10}>
                <Text>
                  Client{" "}
                  {selectedClient === null ? "" : <CheckCircleFilled style={{ color: "green" }} />}
                </Text>
              </Col>
              <Col span={14}>
                <Select
                  value={selectedClient}
                  style={{ width: "100%" }}
                  onChange={handleClient}
                  showSearch
                  loading={loadingClients}
                  placeholder="Client"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  }>
                  {clients &&
                    clients.map((client, id) => (
                      <Option
                        id={client.id}
                        key={id}
                        profit={client.profitability}
                        value={client.client}>
                        {client.client}
                      </Option>
                    ))}
                </Select>
              </Col>
              <Col span={10}>
                <Text>
                  Product{" "}
                  {productName === null ? "" : <CheckCircleFilled style={{ color: "green" }} />}
                </Text>
              </Col>
              <Col span={14}>
                <Input
                  value={productName}
                  allowClear
                  onChange={(event) => setProductName(event.target.value)}
                  placeholder="Product name"
                  style={{ width: "100%" }}
                />
              </Col>

              <Col span={10}>
                <Text>
                  Knives{" "}
                  {selectedKnifeCode === "none" ? (
                    ""
                  ) : (
                    <CheckCircleFilled style={{ color: "green" }} />
                  )}
                </Text>
              </Col>
              <Col span={kniveButtonText === "Select" ? 14 : 12}>
                <CalculationsPopup
                  selectedMachine={selectedMachine}
                  setNumberOfColumns={setNumberOfColumns}
                  machineAlsm={machineAlsm}
                  setKniveSpaceBetweenRows={setKniveSpaceBetweenRows}
                  setLabelWidth={setLabelWidth}
                  setLabelHeight={setLabelHeight}
                  setSelectedKnifeCode={setSelectedKnifeCode}
                  setSelectedKnifeId={setSelectedKnifeId}
                  setKniveButtonText={setKniveButtonText}
                  kniveButtonText={kniveButtonText}
                  setNewKnife={setNewKnife}
                  setKnifePrice={setKnifePrice}
                  setKnifeShape={setKnifeShape}
                  knifeShape={knifeShape}
                  newKnifeMessage={newKnifeMessage}
                  setNewKnifeMessage={setNewKnifeMessage}
                  newKnifeRadiuss={newKnifeRadiuss}
                  setNewKnifeRadius={setNewKnifeRadius}
                  setNewKnifeFile={setNewKnifeFile}
                />
              </Col>
              {kniveButtonText === "Select" ? (
                ""
              ) : (
                <Col span={2}>
                  <ClearOutlined onClick={() => clearKnives()} style={{ marginLeft: "5px" }} />
                </Col>
              )}

              <Col span={10}>
                <Text>
                  Label width{" "}
                  {labelWidth <= 0 ? "" : <CheckCircleFilled style={{ color: "green" }} />}
                </Text>
              </Col>
              <Col span={14}>
                <InputNumber
                  value={labelWidth}
                  min={0}
                  onChange={handleLabelWidth}
                  placeholder="Label width"
                  style={{ width: "100%" }}
                />
              </Col>
              <Col span={10}>
                <Text>
                  Label height{" "}
                  {labelHeight <= 0 ? "" : <CheckCircleFilled style={{ color: "green" }} />}
                </Text>
              </Col>
              <Col span={14}>
                <InputNumber
                  value={labelHeight}
                  min={0}
                  onChange={handleLabelHeight}
                  placeholder="Height"
                  style={{ width: "100%" }}
                />
              </Col>

              <Col span={8}>
                <Text>
                  Material{" "}
                  {selectedMaterial === "none" ? (
                    ""
                  ) : (
                    <CheckCircleFilled style={{ color: "green" }} />
                  )}
                </Text>
              </Col>
              <Col span={16}>
                <Select
                  value={selectedMaterial}
                  onChange={handleMaterial}
                  loading={materialLoading}
                  showSearch
                  style={{ width: "100%" }}
                  placeholder="Material"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  filterSort={(optionA, optionB) =>
                    optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                  }>
                  {material &&
                    material.map((material, id) => (
                      <Option
                        eurM2={material.eurM2}
                        widths={material.widths}
                        gM2={material.gM2}
                        id={material.id}
                        key={id}
                        value={material.material}>
                        {material.material}
                      </Option>
                    ))}
                </Select>
              </Col>
              <Col span={8}>
                <Text>
                  Format
                  {formatWidth <= 0 ? (
                    ""
                  ) : <CheckCircleFilled style={{ color: "green" }} /> && numberOfColumns <= 0 ? (
                    ""
                  ) : (
                    <CheckCircleFilled style={{ color: "green", marginLeft: "2px" }} />
                  )}
                </Text>
              </Col>
              <Col span={8}>
                {/* <InputNumber min={0} value={formatWidth} onChange={(value) => setFormatWidth(value)} placeholder="Width" style={{ width: "100%" }} /> */}
                <Select
                  style={{
                    width: "100%",
                  }}
                  value={formatWidth}
                  onChange={handleFormatWidth}>
                  {formatWidthList &&
                    formatWidthList.map((res, index) => (
                      <Option key={index} value={res}>
                        {res}
                      </Option>
                    ))}
                </Select>
              </Col>
              <Col span={8}>
                <InputNumber
                  min={0}
                  value={numberOfColumns}
                  onChange={handleNumberOfColumns}
                  placeholder="Nr.of columns"
                  style={{ width: "100%" }}
                />
              </Col>
              <Col span={8}>Row Balance</Col>
              <Col span={16}>
                <InputNumber
                  disabled
                  value={rowBalance}
                  precision={2}
                  placeholder="Row balance"
                  style={{ width: "100%" }}
                />
              </Col>
              {tooltipRowBalance ? (
                <>
                  <Col span={24}>
                    <Text style={{ fontSize: "12px" }} italic type="danger">
                      Row Balance stands for "excess material". This means that if Row Balance
                      number is higher than 10, you are wasting material. If the Row balance is with
                      negative value, you will not be able to print!
                    </Text>
                  </Col>
                </>
              ) : (
                ""
              )}
              <Col span={24}>
                <Divider>Comment</Divider>
                <TextArea
                  showCount
                  value={userComment && userComment}
                  style={{
                    height: 90,
                    marginBottom: 24,
                    allowClear: true,
                  }}
                  onChange={(e) => setUserComment(e.target.value)}
                  placeholder="Add a comment"
                />
              </Col>
              <Divider />
              <Col flex="auto">
                <Text>Show Advanced settings</Text>
              </Col>
              <Col flex="30px">
                <Switch
                  checked={visible ? true : false}
                  size="default"
                  checkedChildren="ON"
                  unCheckedChildren="OFF"
                  onChange={() => setVisible(!visible)}
                />
              </Col>
              {/* ADVANCED FEATURES FOR PRICE CALULCATION */}
              {visible ? (
                <>
                  <Divider>Advanced Settings</Divider>

                  <Col span={10}>Profit Slider</Col>
                  <Col span={10}>
                    <Slider
                      included={false}
                      tooltip={{ formatter }}
                      value={extraProfitSlider}
                      min={-10}
                      max={10}
                      onChange={(value) => setExtraProfitSlider(value)}
                    />
                  </Col>

                  <Col flex="auto">
                    <Text>{extraProfitSlider + "%"}</Text>
                  </Col>

                  <Col span={10}>Changable Space</Col>
                  <Col span={7}>
                    <Switch checked={changableSpace} onChange={setChangableSpace} />
                  </Col>
                  <Col span={10}>Fixed Price</Col>
                  <Col span={7}>
                    <Switch checked={fixedPrice ? true : false} onChange={handleFixedPrice} />
                  </Col>
                  {fixedPrice === true ? (
                    <>
                      <Divider>Fixed Price</Divider>
                      <Col span={15}>
                        <Text>Fixed Price (eur)</Text>
                      </Col>
                      <Col span={9}>
                        <InputNumber
                          value={totalFixedPrice}
                          onChange={(value) => setTotalFixedPrice(value)}
                          disabled={disableFixedPriceButton}
                          min={0}
                          style={{ width: "100%" }}
                          placeholder="0"
                        />
                      </Col>
                      <Divider>Fixed Dynamic Price</Divider>
                      {dynamicFixedPrice && dynamicFixedPrice.length !== 0 ? (
                        <>
                          <Col flex="42%">
                            <Text>Count</Text>
                          </Col>
                          <Col flex="58%">
                            <Text>Price</Text>
                          </Col>
                        </>
                      ) : (
                        ""
                      )}
                      {dynamicFixedPrice && dynamicFixedPrice.length !== 0
                        ? dynamicFixedPrice.map((inputField, index) => (
                            <div key={index}>
                              <Row justify="end" align="middle">
                                <Col span={20}>
                                  <Input.Group compact>
                                    <Input
                                      type="number"
                                      style={{ width: "50%" }}
                                      name="quantity"
                                      value={inputField.quantity}
                                      onChange={(event) => handleAmountChangeFixed(index, event)}
                                    />
                                    <InputNumber
                                      style={{ width: "50%" }}
                                      min={0}
                                      step={0.01}
                                      value={inputField.price}
                                      onChange={(value) =>
                                        handleAmountChangeFixed(index, "price", value)
                                      }
                                    />
                                  </Input.Group>
                                </Col>
                                <Col span={4}>
                                  <Button
                                    type="primary"
                                    ghost
                                    danger
                                    onClick={() => removeAmountFieldsFixed(index)}>
                                    <CloseCircleOutlined />
                                  </Button>
                                </Col>
                              </Row>
                            </div>
                          ))
                        : ""}

                      <Button type="primary" block onClick={() => handleAddAmountFixed()}>
                        Add More Fixed
                      </Button>
                    </>
                  ) : (
                    ""
                  )}
                  <Divider />
                </>
              ) : (
                ""
              )}
            </Row>
          </Col>

          <Col
            style={{
              paddingRight: 15,
              paddingLeft: 15,
              background: "white",
              borderRadius: "3px",
            }}
            className="gutter-row"
            span={10}>
            {selectedMachine == null ? (
              <>
                <Divider orientation="middle">Please select the machine...</Divider>
                <Skeleton />
              </>
            ) : (
              <>
                <Divider orientation="middle">Configurations for {selectedMachine}</Divider>
                <Tabs
                  centered
                  activeKey={activeKey}
                  items={[
                    {
                      label: `Arsoma`,
                      key: "2",
                      children: arsomaTab,
                      disabled: true,
                    },
                    {
                      label: `Cutter`,
                      key: "0",
                      children: `There are no settings for cutter calculation`,
                      disabled: true,
                    },
                    {
                      label: `Viva`,
                      key: "1",
                      children: vivaTab,
                      disabled: true,
                    },
                  ]}
                />
              </>
            )}
          </Col>
          <Col style={style} className="gutter-row" span={7}>
            <Row
              style={{ paddingRight: 45, paddingLeft: 45, paddingBottom: 45 }}
              align="middle"
              gutter={[2, 5]}>
              <Col align="center" span={24}>
                <Divider></Divider>
                <Space>
                  <Text>Show Dynamic Prices</Text>
                  <Switch onChange={changeDynamicPriceSwitch} />
                </Space>
              </Col>

              {dynamicPriceHidden ? (
                <>
                  <Divider orientation="middle">Price Is Fixed!</Divider>
                  <Col align="center" span={24}>
                    <Text code type="danger">
                      Check "Advanced Settings"
                    </Text>
                  </Col>
                </>
              ) : (
                <>
                  {/* <Divider orientation="middle">Total price</Divider>
                           <Col span={15}>
                              <Text>Price (eur)</Text>
                           </Col>
                           <Col span={9}>
                              <InputNumber value={totalPrice} min={0} style={{ width: "100%" }} placeholder="0" />
                           </Col> */}

                  <Divider>Prices</Divider>
                  <Col flex="42%">
                    <Text>Count</Text>
                  </Col>
                  <Col flex="58%">
                    <Text>Price</Text>
                  </Col>
                  {dynamicPrice.map((inputField, index) => (
                    <div key={index}>
                      <Row justify="end" align="middle">
                        <Col span={20}>
                          <Input.Group compact>
                            <Input
                              type="number"
                              style={{ width: "50%" }}
                              name="quantity"
                              value={inputField.quantity}
                              onChange={(event) => handleAmountChange(index, event)}
                            />
                            <Input
                              style={{ width: "50%" }}
                              value={isFinite(inputField.price) ? inputField.price : 0}
                            />
                          </Input.Group>
                        </Col>
                        <Col span={4}>
                          <Button
                            type="primary"
                            ghost
                            danger
                            disabled={dynamicPrice.length === 1}
                            onClick={() => removeAmountFields(index)}>
                            <CloseCircleOutlined />
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  ))}

                  <Button type="dashed" block onClick={() => handleAddAmount()}>
                    Add More
                  </Button>

                  <Divider />
                </>
              )}

              {/* CHECKS IF THE JOB IS NEW */}
              {newKnife || newJob ? (
                <>
                  <Divider orientation="middle">Startup Costs</Divider>
                  {/* IF NEW KNIFE, returns the price */}
                  <Col span={24}>{newKnife ? <>{knifeStartupPrice()}</> : ""}</Col>
                  {/* IF NEW JOB, returns the plate startup */}
                  <Col span={24}>{newJob ? <>{plateStartup()}</> : ""}</Col>

                  <Space>
                    <Text>Total Startup (eur) :</Text>
                    <Text style={{ color: "#1677ff" }}>{totalPlateCost + knifePrice}</Text>
                  </Space>
                  <Divider />
                </>
              ) : (
                ""
              )}

              {cmykColors > 0 ||
              pantoneColors > 0 ||
              coveringWCount > 0 ||
              varnishUse > 0 ||
              goldOrSilver > 0 ||
              reliefRunningMeters > 0 ||
              foilCount > 0 ? (
                <>
                  <Col span={10}>
                    <Text>Product File</Text>
                  </Col>
                  <Col span={14}>
                    <Link target="_blank" href={adminProductFileLink}>
                      <Space>
                        <FileOutlined />
                        View File
                      </Space>
                    </Link>
                  </Col>
                </>
              ) : (
                ""
              )}
              <Col span={24}>
                <Divider>Comment from Admin</Divider>
                <TextArea
                  showCount
                  value={adminComment && adminComment}
                  style={{
                    height: 90,
                    marginBottom: 24,
                    allowClear: true,
                  }}
                  onChange={(e) => setAdminComment(e.target.value)}
                  placeholder="Add a comment"
                />
              </Col>
              {wasSentFromDesigner && wasSentFromDesigner ? (
                <>
                  <Col span={24}>
                    <Divider>Comment from Designer</Divider>
                    <TextArea
                      showCount
                      value={designerComment && designerComment}
                      style={{
                        height: 90,
                        marginBottom: 24,
                        allowClear: true,
                      }}
                      disabled={true}
                      placeholder="no comment"
                    />
                  </Col>
                </>
              ) : (
                ""
              )}
              <Button
                style={{ marginTop: "15px" }}
                onClick={() => handleTheTotalCalculate(labelCount)}
                type="primary"
                block>
                Calculate
              </Button>
              {returnCorrectButton()}
            </Row>
          </Col>
        </Row>
      </>

      {/* CALCULATIONS END */}
    </>
  )
}
